(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './androidx-compose-runtime-runtime.js', './compose-multiplatform-core-compose-ui-ui.js', './compose-multiplatform-core-compose-animation-animation-core.js', './androidx-collection-collection.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './kotlinx-coroutines-core.js', './compose-multiplatform-core-compose-ui-ui-graphics.js', './compose-multiplatform-core-compose-ui-ui-geometry.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./androidx-compose-runtime-runtime.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./compose-multiplatform-core-compose-animation-animation-core.js'), require('./androidx-collection-collection.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./kotlinx-coroutines-core.js'), require('./compose-multiplatform-core-compose-ui-ui-graphics.js'), require('./compose-multiplatform-core-compose-ui-ui-geometry.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-animation-animation'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-multiplatform-core-compose-animation-animation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'compose-multiplatform-core-compose-animation-animation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-animation-animation-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation'. Its dependency 'compose-multiplatform-core-compose-animation-animation-core' was not found. Please, check whether 'compose-multiplatform-core-compose-animation-animation-core' is loaded prior to 'compose-multiplatform-core-compose-animation-animation'.");
    }
    if (typeof globalThis['androidx-collection-collection'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation'. Its dependency 'androidx-collection-collection' was not found. Please, check whether 'androidx-collection-collection' is loaded prior to 'compose-multiplatform-core-compose-animation-animation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'compose-multiplatform-core-compose-animation-animation'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'compose-multiplatform-core-compose-animation-animation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation'. Its dependency 'compose-multiplatform-core-compose-ui-ui-graphics' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-graphics' is loaded prior to 'compose-multiplatform-core-compose-animation-animation'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-geometry'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation'. Its dependency 'compose-multiplatform-core-compose-ui-ui-geometry' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-geometry' is loaded prior to 'compose-multiplatform-core-compose-animation-animation'.");
    }
    globalThis['compose-multiplatform-core-compose-animation-animation'] = factory(typeof globalThis['compose-multiplatform-core-compose-animation-animation'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-animation-animation'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-compose-runtime-runtime'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['compose-multiplatform-core-compose-animation-animation-core'], globalThis['androidx-collection-collection'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['kotlinx-coroutines-core'], globalThis['compose-multiplatform-core-compose-ui-ui-graphics'], globalThis['compose-multiplatform-core-compose-ui-ui-geometry']);
  }
}(function (_, kotlin_kotlin, kotlin_androidx_compose_runtime_runtime, kotlin_org_jetbrains_compose_ui_ui, kotlin_org_jetbrains_compose_animation_animation_core, kotlin_androidx_collection_collection, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_compose_ui_ui_graphics, kotlin_org_jetbrains_compose_ui_ui_geometry) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var sign = Math.sign;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var VOID = kotlin_kotlin.$_$.d;
  var mutableFloatStateOf = kotlin_androidx_compose_runtime_runtime.$_$.v1;
  var KMutableProperty1 = kotlin_kotlin.$_$.wi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var Companion_instance = kotlin_org_jetbrains_compose_ui_ui.$_$.ec;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.dc;
  var updateTransition = kotlin_org_jetbrains_compose_animation_animation_core.$_$.b2;
  var get_LocalLayoutDirection = kotlin_org_jetbrains_compose_ui_ui.$_$.a7;
  var mutableStateListOf = kotlin_androidx_compose_runtime_runtime.$_$.y1;
  var mutableScatterMapOf = kotlin_androidx_collection_collection.$_$.j1;
  var equals = kotlin_kotlin.$_$.sf;
  var rememberComposableLambda = kotlin_androidx_compose_runtime_runtime.$_$.c;
  var get_currentCompositeKeyHashCode = kotlin_androidx_compose_runtime_runtime.$_$.l1;
  var materialize = kotlin_org_jetbrains_compose_ui_ui.$_$.wa;
  var Companion_getInstance_1 = kotlin_org_jetbrains_compose_ui_ui.$_$.vb;
  var invalidApplier = kotlin_androidx_compose_runtime_runtime.$_$.r1;
  var Applier = kotlin_androidx_compose_runtime_runtime.$_$.h;
  var isInterface = kotlin_kotlin.$_$.rg;
  var _Updater___init__impl__rbfxm8 = kotlin_androidx_compose_runtime_runtime.$_$.r2;
  var Updater__set_impl_v7kwss = kotlin_androidx_compose_runtime_runtime.$_$.t2;
  var Updater__reconcile_impl_1mfi6g = kotlin_androidx_compose_runtime_runtime.$_$.s2;
  var Companion_getInstance_2 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g4;
  var IntSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t;
  var spring = kotlin_org_jetbrains_compose_animation_animation_core.$_$.y1;
  var fromInt = kotlin_kotlin.$_$.pe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var Long = kotlin_kotlin.$_$.kn;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var _IntSize___init__impl__emcjft = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d3;
  var LayoutDirection_Ltr_getInstance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k4;
  var mutableStateOf = kotlin_androidx_compose_runtime_runtime.$_$.b2;
  var foldIn = kotlin_org_jetbrains_compose_ui_ui.$_$.pa;
  var all = kotlin_org_jetbrains_compose_ui_ui.$_$.oa;
  var then = kotlin_org_jetbrains_compose_ui_ui.$_$.ra;
  var ParentDataModifier = kotlin_org_jetbrains_compose_ui_ui.$_$.a4;
  var ModifierNodeElement = kotlin_org_jetbrains_compose_ui_ui.$_$.m5;
  var hashCode = kotlin_kotlin.$_$.bg;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var _IntSize___get_packedValue__impl__uho7jf = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f3;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var convertToInt = kotlin_kotlin.$_$.le;
  var KMutableProperty0 = kotlin_kotlin.$_$.vi;
  var getLocalDelegateReference = kotlin_kotlin.$_$.wf;
  var rememberUpdatedState = kotlin_androidx_compose_runtime_runtime.$_$.g2;
  var get_VectorConverter = kotlin_org_jetbrains_compose_animation_animation_core.$_$.x;
  var createDeferredAnimation = kotlin_org_jetbrains_compose_animation_animation_core.$_$.p1;
  var clipToBounds = kotlin_org_jetbrains_compose_ui_ui.$_$.g;
  var isTransitioningTo = kotlin_org_jetbrains_compose_animation_animation_core.$_$.q;
  var Segment = kotlin_org_jetbrains_compose_animation_animation_core.$_$.r;
  var _IntOffset___get_x__impl__qiqr5o = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b3;
  var _IntOffset___get_y__impl__2avpwj = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c3;
  var get_lastIndex = kotlin_kotlin.$_$.ga;
  var compareTo = kotlin_kotlin.$_$.nf;
  var get_lastIndex_0 = kotlin_kotlin.$_$.fa;
  var MeasurePolicy = kotlin_org_jetbrains_compose_ui_ui.$_$.r3;
  var tween = kotlin_org_jetbrains_compose_animation_animation_core.$_$.z1;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  var DisposableEffect = kotlin_androidx_compose_runtime_runtime.$_$.q;
  var layout = kotlin_org_jetbrains_compose_ui_ui.$_$.p4;
  var get_VisibilityThreshold = kotlin_org_jetbrains_compose_animation_animation_core.$_$.c1;
  var Enum = kotlin_kotlin.$_$.en;
  var createChildTransitionInternal = kotlin_org_jetbrains_compose_animation_animation_core.$_$.o1;
  var produceState = kotlin_androidx_compose_runtime_runtime.$_$.d2;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.z3;
  var KProperty0 = kotlin_kotlin.$_$.xi;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var FlowCollector = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p1;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var ProduceStateScope = kotlin_androidx_compose_runtime_runtime.$_$.y;
  var snapshotFlow = kotlin_androidx_compose_runtime_runtime.$_$.h2;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var Node = kotlin_org_jetbrains_compose_ui_ui.$_$.qa;
  var LayoutModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.k5;
  var androidx_compose_ui_Modifier_Node$stableprop_getter = kotlin_org_jetbrains_compose_ui_ui.$_$.ua;
  var TwoWayConverter = kotlin_org_jetbrains_compose_animation_animation_core.$_$.t;
  var ColorSpaces_getInstance = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.z3;
  var Color__convert_impl_so5m8t = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.y2;
  var _Color___get_red__impl__cwrsk6 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.b3;
  var _Color___get_green__impl__bta9rs = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.z2;
  var _Color___get_blue__impl__xwez13 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.w2;
  var _Color___get_alpha__impl__wcfyv1 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.v2;
  var AnimationVector4D = kotlin_org_jetbrains_compose_animation_animation_core.$_$.h;
  var Color = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.w;
  var Color_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.y;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var plus = kotlin_kotlin.$_$.eb;
  var Companion_getInstance_3 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e4;
  var get_VectorConverter_0 = kotlin_org_jetbrains_compose_animation_animation_core.$_$.u;
  var _Color___get_colorSpace__impl__jqqozk = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.x2;
  var Companion_getInstance_4 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.g4;
  var graphicsLayer = kotlin_org_jetbrains_compose_ui_ui.$_$.h1;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var toString = kotlin_kotlin.$_$.hp;
  var toString_0 = kotlin_kotlin.$_$.hh;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var getNumberHashCode = kotlin_kotlin.$_$.xf;
  var TransformOrigin__toString_impl_nn7ftd = kotlin_org_jetbrains_compose_ui_ui.$_$.bb;
  var TransformOrigin__hashCode_impl_pmqpcw = kotlin_org_jetbrains_compose_ui_ui.$_$.ya;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var get_VectorConverter_1 = kotlin_org_jetbrains_compose_animation_animation_core.$_$.y;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var requireLayoutCoordinates = kotlin_org_jetbrains_compose_ui_ui.$_$.m6;
  var toRawBits = kotlin_kotlin.$_$.fp;
  var _Size___init__impl__aywn0g = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c1;
  var Size = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.j;
  var Companion_getInstance_5 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.n1;
  var positionInParent = kotlin_org_jetbrains_compose_ui_ui.$_$.s4;
  var _Offset___get_packedValue__impl__xh2k8q = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.y;
  var bitwiseXor = kotlin_kotlin.$_$.ie;
  var _Offset___init__impl__c168vi = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.r;
  var onMeasureResultChanged = kotlin_org_jetbrains_compose_ui_ui.$_$.a5;
  var DrawModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.b5;
  var IntOffset = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.r;
  var Constraints = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a;
  var IntOffset__minus_impl_4m69hb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.x2;
  var constrain = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e1;
  var IntOffset__plus_impl_nqoa9b = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.z2;
  var get_VisibilityThreshold_0 = kotlin_org_jetbrains_compose_animation_animation_core.$_$.b1;
  var Companion_getInstance_6 = kotlin_org_jetbrains_compose_ui_ui.$_$.kb;
  var _TransformOrigin___get_pivotFractionX__impl__a9pmci = kotlin_org_jetbrains_compose_ui_ui.$_$.za;
  var _TransformOrigin___get_pivotFractionY__impl__ijwupp = kotlin_org_jetbrains_compose_ui_ui.$_$.ab;
  var AnimationVector2D = kotlin_org_jetbrains_compose_animation_animation_core.$_$.g;
  var TransformOrigin = kotlin_org_jetbrains_compose_ui_ui.$_$.f1;
  var TransformOrigin_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.g1;
  var _IntOffset___init__impl__rq8h7b = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.v2;
  var toNumber = kotlin_kotlin.$_$.bf;
  var compare = kotlin_kotlin.$_$.je;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var numberToLong = kotlin_kotlin.$_$.we;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var Companion_getInstance_7 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.m1;
  var get_VisibilityThreshold_1 = kotlin_org_jetbrains_compose_animation_animation_core.$_$.z;
  var MutableScatterMap = kotlin_androidx_collection_collection.$_$.n;
  var animateValueAsState = kotlin_org_jetbrains_compose_animation_animation_core.$_$.l1;
  var coerceIn = kotlin_kotlin.$_$.di;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var generateDecayAnimationSpec = kotlin_org_jetbrains_compose_animation_animation_core.$_$.s1;
  var divide = kotlin_kotlin.$_$.ne;
  var multiply = kotlin_kotlin.$_$.ue;
  var get_LocalDensity = kotlin_org_jetbrains_compose_ui_ui.$_$.t6;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ContentTransform, 'ContentTransform');
  initMetadataForClass(ChildData, 'ChildData', VOID, VOID, [ParentDataModifier]);
  initMetadataForClass(SizeModifierElement, 'SizeModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(LayoutModifierNodeWithPassThroughIntrinsics, 'LayoutModifierNodeWithPassThroughIntrinsics', VOID, Node, [LayoutModifierNode]);
  initMetadataForClass(SizeModifierNode, 'SizeModifierNode', VOID, LayoutModifierNodeWithPassThroughIntrinsics);
  initMetadataForClass(AnimatedContentTransitionScopeImpl, 'AnimatedContentTransitionScopeImpl', VOID, VOID, [Segment]);
  initMetadataForClass(AnimatedContentScopeImpl, 'AnimatedContentScopeImpl');
  initMetadataForClass(AnimatedContentMeasurePolicy, 'AnimatedContentMeasurePolicy', VOID, VOID, [MeasurePolicy]);
  initMetadataForClass(SizeTransformImpl, 'SizeTransformImpl');
  initMetadataForClass(AnimatedContent$$inlined$fastForEach$1$4$1$1);
  initMetadataForClass(EnterExitState, 'EnterExitState', VOID, Enum);
  initMetadataForClass(AnimatedVisibilityScopeImpl, 'AnimatedVisibilityScopeImpl');
  initMetadataForClass(AnimatedEnterExitMeasurePolicy, 'AnimatedEnterExitMeasurePolicy', VOID, VOID, [MeasurePolicy]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(AnimatedEnterExitImpl$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AnimatedEnterExitImpl$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(EnterTransition, 'EnterTransition');
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(ExitTransition, 'ExitTransition');
  initMetadataForClass(TransitionData, 'TransitionData', TransitionData);
  initMetadataForClass(EnterTransitionImpl, 'EnterTransitionImpl', VOID, EnterTransition);
  initMetadataForClass(Fade, 'Fade');
  initMetadataForClass(Slide, 'Slide');
  initMetadataForClass(ChangeSize, 'ChangeSize');
  initMetadataForClass(Scale, 'Scale');
  initMetadataForClass(ExitTransitionImpl, 'ExitTransitionImpl', VOID, ExitTransition);
  initMetadataForClass(VeilModifierElement, 'VeilModifierElement', VOID, ModifierNodeElement);
  initMetadataForInterface(GraphicsLayerBlockForEnterExit, 'GraphicsLayerBlockForEnterExit');
  initMetadataForClass(EnterExitTransitionElement, 'EnterExitTransitionElement', VOID, ModifierNodeElement);
  initMetadataForClass(VeilModifierNode, 'VeilModifierNode', VOID, Node, [DrawModifierNode]);
  initMetadataForClass(EnterExitTransitionModifierNode, 'EnterExitTransitionModifierNode', VOID, LayoutModifierNodeWithPassThroughIntrinsics);
  initMetadataForClass(sam$androidx_compose_animation_GraphicsLayerBlockForEnterExit$0, 'sam$androidx_compose_animation_GraphicsLayerBlockForEnterExit$0', VOID, VOID, [GraphicsLayerBlockForEnterExit, FunctionAdapter]);
  initMetadataForClass(FlingInfo, 'FlingInfo');
  initMetadataForClass(FlingCalculator, 'FlingCalculator');
  initMetadataForInterface(BoundsTransform, 'BoundsTransform');
  initMetadataForInterface(PlaceholderSize, 'PlaceholderSize');
  initMetadataForClass(sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0, 'sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0', VOID, VOID, [PlaceholderSize, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0_0, 'sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0', VOID, VOID, [PlaceholderSize, FunctionAdapter]);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(SharedContentState, 'SharedContentState');
  function sharedElement$default(_this__u8e3s4, sharedContentState, animatedVisibilityScope, boundsTransform, placeholderSize, renderInOverlayDuringTransition, zIndexInOverlay, clipInOverlayDuringTransition, $super) {
    boundsTransform = boundsTransform === VOID ? SharedTransitionDefaults_getInstance().xf9_1 : boundsTransform;
    placeholderSize = placeholderSize === VOID ? Companion_getInstance_10().pf9_1 : placeholderSize;
    renderInOverlayDuringTransition = renderInOverlayDuringTransition === VOID ? true : renderInOverlayDuringTransition;
    zIndexInOverlay = zIndexInOverlay === VOID ? 0.0 : zIndexInOverlay;
    clipInOverlayDuringTransition = clipInOverlayDuringTransition === VOID ? get_ParentClip() : clipInOverlayDuringTransition;
    return $super === VOID ? this.vf9(_this__u8e3s4, sharedContentState, animatedVisibilityScope, boundsTransform, placeholderSize, renderInOverlayDuringTransition, zIndexInOverlay, clipInOverlayDuringTransition) : $super.vf9.call(this, _this__u8e3s4, sharedContentState, animatedVisibilityScope, boundsTransform, placeholderSize, renderInOverlayDuringTransition, zIndexInOverlay, clipInOverlayDuringTransition);
  }
  function rememberSharedContentState(key, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.m30(800730162);
    var tmp0 = this.zf9(key, SharedContentConfig_instance, $composer_0, 48 | 14 & $changed | 896 & $changed << 3);
    $composer_0.n30();
    return tmp0;
  }
  function rememberSharedContentState_0(key, config, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.m30(-148945892);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.k31(key);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = new SharedContentState(key, config);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    // Inline function 'kotlin.also' call
    var this_0 = tmp;
    this_0.uf9(config);
    $composer_0.n30();
    return this_0;
  }
  initMetadataForInterface(SharedTransitionScope, 'SharedTransitionScope');
  initMetadataForObject(SharedContentConfig, 'SharedContentConfig');
  initMetadataForClass(sam$androidx_compose_animation_BoundsTransform$0, 'sam$androidx_compose_animation_BoundsTransform$0', VOID, VOID, [BoundsTransform, FunctionAdapter]);
  initMetadataForObject(SharedTransitionDefaults, 'SharedTransitionDefaults');
  initMetadataForClass(ParentClip$1);
  initMetadataForClass(FlingResult, 'FlingResult');
  initMetadataForObject(AndroidFlingSpline, 'AndroidFlingSpline');
  initMetadataForClass(SplineBasedFloatDecayAnimationSpec, 'SplineBasedFloatDecayAnimationSpec');
  //endregion
  function get_UnspecifiedSize() {
    _init_properties_AnimatedContent_kt__n7dixw();
    return UnspecifiedSize;
  }
  var UnspecifiedSize;
  var androidx_compose_animation_ContentTransform$stable;
  var androidx_compose_animation_AnimatedContentTransitionScopeImpl_ChildData$stable;
  var androidx_compose_animation_AnimatedContentTransitionScopeImpl$stable;
  function ContentTransform$_get_targetContentZIndex_$ref_j277yp() {
    return constructCallableReference(function (p0) {
      return p0.lf1();
    }, 1, 0, 230);
  }
  function ContentTransform$_set_targetContentZIndex_$ref_1ey6ar() {
    return constructCallableReference(function (p0, p1) {
      p0.mf1(p1);
      return Unit_instance;
    }, 2, 0, 231);
  }
  function ContentTransform(targetContentEnter, initialContentExit, targetContentZIndex, sizeTransform) {
    targetContentZIndex = targetContentZIndex === VOID ? 0.0 : targetContentZIndex;
    sizeTransform = sizeTransform === VOID ? SizeTransform() : sizeTransform;
    this.hf1_1 = targetContentEnter;
    this.if1_1 = initialContentExit;
    this.jf1_1 = mutableFloatStateOf(targetContentZIndex);
    this.kf1_1 = sizeTransform;
  }
  protoOf(ContentTransform).mf1 = function (_set____db54di) {
    var tmp0 = this.jf1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ContentTransform$_get_targetContentZIndex_$ref_j277yp();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('targetContentZIndex', 1, tmp, tmp_0, ContentTransform$_set_targetContentZIndex_$ref_1ey6ar());
    tmp0.i45(_set____db54di);
    return Unit_instance;
  };
  protoOf(ContentTransform).lf1 = function () {
    var tmp0 = this.jf1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ContentTransform$_get_targetContentZIndex_$ref_j277yp();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('targetContentZIndex', 1, tmp, tmp_0, ContentTransform$_set_targetContentZIndex_$ref_1ey6ar());
    return tmp0.j45();
  };
  function togetherWith(_this__u8e3s4, exit) {
    _init_properties_AnimatedContent_kt__n7dixw();
    return new ContentTransform(_this__u8e3s4, exit);
  }
  function AnimatedContent(targetState, modifier, transitionSpec, contentAlignment, label, contentKey, content, $composer, $changed, $default) {
    _init_properties_AnimatedContent_kt__n7dixw();
    var modifier_0 = {_v: modifier};
    var transitionSpec_0 = {_v: transitionSpec};
    var contentAlignment_0 = {_v: contentAlignment};
    var label_0 = {_v: label};
    var contentKey_0 = {_v: contentKey};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1501828832);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(targetState) : $composer_0.q31(targetState)) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(transitionSpec_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(contentAlignment_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(label_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(contentKey_0._v) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 4) === 0)) {
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = AnimatedContent$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        transitionSpec_0._v = tmp;
      }
      if (!(($default & 8) === 0)) {
        contentAlignment_0._v = Companion_getInstance_0().k8t_1;
      }
      if (!(($default & 16) === 0)) {
        label_0._v = 'AnimatedContent';
      }
      if (!(($default & 32) === 0)) {
        // Inline function 'androidx.compose.runtime.cache' call
        var this_1 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_0 = this_1.i31();
        var tmp_0;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = AnimatedContent$lambda_0;
          this_1.j31(value_0);
          tmp_0 = value_0;
        } else {
          tmp_0 = it_0;
        }
        contentKey_0._v = tmp_0;
      }
      var transition = updateTransition(targetState, label_0._v, $composer_0, 8 & $dirty | 14 & $dirty | 112 & $dirty >> 9, 0);
      AnimatedContent_0(transition, modifier_0._v, transitionSpec_0._v, contentAlignment_0._v, contentKey_0._v, content, $composer_0, 112 & $dirty | 896 & $dirty | 7168 & $dirty | 57344 & $dirty >> 3 | 458752 & $dirty >> 3, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(AnimatedContent$lambda_1(targetState, modifier_0, transitionSpec_0, contentAlignment_0, label_0, contentKey_0, content, $changed, $default));
    }
  }
  function AnimatedContent_0(_this__u8e3s4, modifier, transitionSpec, contentAlignment, contentKey, content, $composer, $changed, $default) {
    _init_properties_AnimatedContent_kt__n7dixw();
    var modifier_0 = {_v: modifier};
    var transitionSpec_0 = {_v: transitionSpec};
    var contentAlignment_0 = {_v: contentAlignment};
    var contentKey_0 = {_v: contentKey};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(511725103);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(_this__u8e3s4) ? 4 : 2);
    if (!(($default & 1) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(transitionSpec_0._v) ? 256 : 128);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(contentAlignment_0._v) ? 2048 : 1024);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(contentKey_0._v) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74899) === 74898), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 2) === 0)) {
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = AnimatedContent$lambda_2;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        transitionSpec_0._v = tmp;
      }
      if (!(($default & 4) === 0)) {
        contentAlignment_0._v = Companion_getInstance_0().k8t_1;
      }
      if (!(($default & 8) === 0)) {
        // Inline function 'androidx.compose.runtime.cache' call
        var this_1 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_0 = this_1.i31();
        var tmp_0;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = AnimatedContent$lambda_3;
          this_1.j31(value_0);
          tmp_0 = value_0;
        } else {
          tmp_0 = it_0;
        }
        contentKey_0._v = tmp_0;
      }
      var tmp0 = get_LocalLayoutDirection();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var layoutDirection = $composer_1.u31(tmp0);
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 14) === 4;
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_0.i31();
      var tmp_1;
      if (invalid || it_1 === Companion_getInstance().f30_1) {
        var value_1 = new AnimatedContentTransitionScopeImpl(_this__u8e3s4, contentAlignment_0._v, layoutDirection);
        tmp0_0.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var rootScope = tmp_1;
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = ($dirty & 14) === 4;
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_1.i31();
      var tmp_2;
      if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = mutableStateListOf([_this__u8e3s4.v70()]);
        tmp0_1.j31(value_2);
        tmp_2 = value_2;
      } else {
        tmp_2 = it_2;
      }
      var currentlyVisible = tmp_2;
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = ($dirty & 14) === 4;
      // Inline function 'kotlin.let' call
      var it_3 = tmp0_2.i31();
      var tmp_3;
      if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = mutableScatterMapOf();
        tmp0_2.j31(value_3);
        tmp_3 = value_3;
      } else {
        tmp_3 = it_3;
      }
      var contentMap = tmp_3;
      if (!currentlyVisible.lh(_this__u8e3s4.v70())) {
        currentlyVisible.c3();
        currentlyVisible.zz(_this__u8e3s4.v70());
      }
      if (equals(_this__u8e3s4.v70(), _this__u8e3s4.o70())) {
        if (!(currentlyVisible.n1() === 1) || !equals(currentlyVisible.l1(0), _this__u8e3s4.v70())) {
          currentlyVisible.c3();
          currentlyVisible.zz(_this__u8e3s4.v70());
        }
        if (!(contentMap.n1() === 1) || contentMap.u2(_this__u8e3s4.v70())) {
          contentMap.c3();
        }
        rootScope.of1_1 = contentAlignment_0._v;
        rootScope.pf1_1 = layoutDirection;
      }
      if (!equals(_this__u8e3s4.v70(), _this__u8e3s4.o70()) && !currentlyVisible.lh(_this__u8e3s4.o70())) {
        var tmp$ret$21;
        $l$block: {
          // Inline function 'kotlin.collections.indexOfFirst' call
          var index = 0;
          var _iterator__ex2g4s = currentlyVisible.t();
          while (_iterator__ex2g4s.u()) {
            var item = _iterator__ex2g4s.v();
            if (equals(contentKey_0._v(item), contentKey_0._v(_this__u8e3s4.o70()))) {
              tmp$ret$21 = index;
              break $l$block;
            }
            index = index + 1 | 0;
          }
          tmp$ret$21 = -1;
        }
        var id = tmp$ret$21;
        if (id === -1) {
          currentlyVisible.zz(_this__u8e3s4.o70());
        } else {
          currentlyVisible.mi(id, _this__u8e3s4.o70());
        }
      }
      if (!contentMap.u2(_this__u8e3s4.o70()) || !contentMap.u2(_this__u8e3s4.v70())) {
        $composer_0.m30(1966410449);
        contentMap.c3();
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = currentlyVisible.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index_0 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item_0 = currentlyVisible.l1(index_0);
            // Inline function 'kotlin.run' call
            var dispatchReceiver = rememberComposableLambda(-23915175, true, AnimatedContent$lambda_4(transitionSpec_0, rootScope, _this__u8e3s4, item_0, currentlyVisible, content), $composer_0, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_2 = $composer_0;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_2 = $composer_2.k31(dispatchReceiver);
            // Inline function 'kotlin.let' call
            var it_4 = $composer_2.i31();
            var tmp_4;
            if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
              var value_4 = ComposableLambda$invoke$ref_0(dispatchReceiver);
              $composer_2.j31(value_4);
              tmp_4 = value_4;
            } else {
              tmp_4 = it_4;
            }
            var tmp$ret$25 = tmp_4;
            contentMap.h13(item_0, tmp$ret$25);
          }
           while (inductionVariable <= last);
        $composer_0.n30();
      } else {
        $composer_0.m30(1968995539);
        $composer_0.n30();
      }
      var tmp0_remember$arg$1 = _this__u8e3s4.yep();
      var tmp0_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = !!($composer_0.k31(rootScope) | $composer_0.k31(tmp0_remember$arg$1));
      // Inline function 'kotlin.let' call
      var it_5 = tmp0_3.i31();
      var tmp_5;
      if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = transitionSpec_0._v(rootScope);
        tmp0_3.j31(value_5);
        tmp_5 = value_5;
      } else {
        tmp_5 = it_5;
      }
      var contentTransform = tmp_5;
      var sizeModifier = rootScope.tf1(contentTransform, $composer_0, 0);
      var tmp0_modifier = modifier_0._v.d8v(sizeModifier);
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_6 = this_2.i31();
      var tmp_6;
      if (false || it_6 === Companion_getInstance().f30_1) {
        var value_6 = new AnimatedContentMeasurePolicy(rootScope);
        this_2.j31(value_6);
        tmp_6 = value_6;
      } else {
        tmp_6 = it_6;
      }
      var tmp2 = tmp_6;
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_1 = tmp0_modifier;
      var $composer_3 = $composer_0;
      if (!((0 & 2) === 0))
        modifier_1 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_1);
      var tmp0_4 = Companion_getInstance_1().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_7 = $composer_4.g30();
      if (!isInterface(tmp_7, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_4);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp2, Companion_getInstance_1().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_1().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_1().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_1().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_1().qah_1);
      var $composer_5 = $composer_4;
      $composer_5.m30(-860173498);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_0 = 0;
      var last_0 = currentlyVisible.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_1 = currentlyVisible.l1(index_1);
          $composer_5.o30(-2026002954, contentKey_0._v(item_1));
          var tmp0_safe_receiver = contentMap.w2(item_1);
          if (tmp0_safe_receiver == null) {
            $composer_5.m30(1618454323);
            $composer_5.n30();
          } else {
            $composer_5.m30(-2026001778);
            tmp0_safe_receiver($composer_5, 0);
            $composer_5.n30();
          }
          $composer_5.p30();
        }
         while (inductionVariable_0 <= last_0);
      $composer_5.n30();
      $composer_4.e31();
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(AnimatedContent$lambda_5(_this__u8e3s4, modifier_0, transitionSpec_0, contentAlignment_0, contentKey_0, content, $changed, $default));
    }
  }
  function SizeTransform(clip, sizeAnimationSpec) {
    clip = clip === VOID ? true : clip;
    var tmp;
    if (sizeAnimationSpec === VOID) {
      tmp = SizeTransform$lambda;
    } else {
      tmp = sizeAnimationSpec;
    }
    sizeAnimationSpec = tmp;
    _init_properties_AnimatedContent_kt__n7dixw();
    return new SizeTransformImpl(clip, sizeAnimationSpec);
  }
  function AnimatedContentTransitionScopeImpl$ChildData$_get_isTarget_$ref_3excp4() {
    return constructCallableReference(function (p0) {
      return p0.vf1();
    }, 1, 0, 232);
  }
  function AnimatedContentTransitionScopeImpl$ChildData$_set_isTarget_$ref_iyo398() {
    return constructCallableReference(function (p0, p1) {
      p0.wf1(p1);
      return Unit_instance;
    }, 2, 0, 233);
  }
  function lastContinuousSizeOrDefault($this, default_0) {
    return equals($this.of2_1, get_UnspecifiedSize()) ? default_0 : $this.of2_1;
  }
  function AnimatedContentTransitionScopeImpl$SizeModifierNode$measure$lambda(this$0, $currentSize) {
    return function ($this$animate) {
      var tmp;
      if (equals($this$animate.rep(), this$0.nf2_1.rep())) {
        tmp = lastContinuousSizeOrDefault(this$0, $currentSize);
      } else {
        var tmp0_safe_receiver = this$0.nf2_1.rf1_1.w2($this$animate.rep());
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          var tmp_1 = tmp0_safe_receiver.u1();
          tmp_0 = tmp_1 == null ? null : tmp_1.o5g_1;
        }
        var tmp1_elvis_lhs = tmp_0;
        var tmp_2;
        var tmp_3 = tmp1_elvis_lhs;
        if ((tmp_3 == null ? null : new IntSize(tmp_3)) == null) {
          tmp_2 = Companion_getInstance_2().n5g_1;
        } else {
          tmp_2 = tmp1_elvis_lhs;
        }
        tmp = tmp_2;
      }
      var initial = tmp;
      var tmp2_safe_receiver = this$0.nf2_1.rf1_1.w2($this$animate.o70());
      var tmp_4;
      if (tmp2_safe_receiver == null) {
        tmp_4 = null;
      } else {
        var tmp_5 = tmp2_safe_receiver.u1();
        tmp_4 = tmp_5 == null ? null : tmp_5.o5g_1;
      }
      var tmp3_elvis_lhs = tmp_4;
      var tmp_6;
      var tmp_7 = tmp3_elvis_lhs;
      if ((tmp_7 == null ? null : new IntSize(tmp_7)) == null) {
        tmp_6 = Companion_getInstance_2().n5g_1;
      } else {
        tmp_6 = tmp3_elvis_lhs;
      }
      var target = tmp_6;
      var tmp4_safe_receiver = this$0.mf2_1.u1();
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.pf2(initial, target);
      return tmp5_elvis_lhs == null ? spring(VOID, 400.0) : tmp5_elvis_lhs;
    };
  }
  function AnimatedContentTransitionScopeImpl$SizeModifierNode$measure$lambda_0(this$0, $currentSize) {
    return function (it) {
      var tmp;
      if (equals(it, this$0.nf2_1.rep())) {
        tmp = lastContinuousSizeOrDefault(this$0, $currentSize);
      } else {
        var tmp0_safe_receiver = this$0.nf2_1.rf1_1.w2(it);
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          var tmp_1 = tmp0_safe_receiver.u1();
          tmp_0 = tmp_1 == null ? null : tmp_1.o5g_1;
        }
        var tmp1_elvis_lhs = tmp_0;
        var tmp_2;
        var tmp_3 = tmp1_elvis_lhs;
        if ((tmp_3 == null ? null : new IntSize(tmp_3)) == null) {
          tmp_2 = Companion_getInstance_2().n5g_1;
        } else {
          tmp_2 = tmp1_elvis_lhs;
        }
        tmp = tmp_2;
      }
      return new IntSize(tmp);
    };
  }
  function AnimatedContentTransitionScopeImpl$SizeModifierNode$measure$lambda_1(this$0, $placeable, $measuredSize) {
    return function ($this$layout) {
      var tmp = this$0.nf2_1.of1_1;
      var tmp0 = $placeable.i8y_1;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = $placeable.j8y_1;
      var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$0 = _IntSize___init__impl__emcjft(tmp$ret$1);
      var offset = tmp.f8u(tmp$ret$0, $measuredSize, LayoutDirection_Ltr_getInstance());
      $this$layout.lal($placeable, offset);
      return Unit_instance;
    };
  }
  function ChildData(isTarget) {
    this.uf1_1 = mutableStateOf(isTarget);
  }
  protoOf(ChildData).wf1 = function (_set____db54di) {
    var tmp0 = this.uf1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = AnimatedContentTransitionScopeImpl$ChildData$_get_isTarget_$ref_3excp4();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isTarget', 1, tmp, tmp_0, AnimatedContentTransitionScopeImpl$ChildData$_set_isTarget_$ref_iyo398());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(ChildData).vf1 = function () {
    var tmp0 = this.uf1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = AnimatedContentTransitionScopeImpl$ChildData$_get_isTarget_$ref_3excp4();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isTarget', 1, tmp, tmp_0, AnimatedContentTransitionScopeImpl$ChildData$_set_isTarget_$ref_iyo398());
    return tmp0.u1();
  };
  protoOf(ChildData).aaj = function (_this__u8e3s4, parentData) {
    return this;
  };
  function SizeModifierElement(sizeAnimation, sizeTransform, scope) {
    ModifierNodeElement.call(this);
    this.rf2_1 = sizeAnimation;
    this.sf2_1 = sizeTransform;
    this.tf2_1 = scope;
  }
  protoOf(SizeModifierElement).r3d = function () {
    return new SizeModifierNode(this.rf2_1, this.sf2_1, this.tf2_1);
  };
  protoOf(SizeModifierElement).hashCode = function () {
    var tmp = imul(31, hashCode(this.tf2_1));
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.rf2_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return imul(tmp + tmp$ret$0 | 0, 31) + hashCode(this.sf2_1) | 0;
  };
  protoOf(SizeModifierElement).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof SizeModifierElement) {
      tmp_0 = equals(other.rf2_1, this.rf2_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(other.sf2_1, this.sf2_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SizeModifierElement).uf2 = function (node) {
    node.lf2_1 = this.rf2_1;
    node.mf2_1 = this.sf2_1;
    node.nf2_1 = this.tf2_1;
  };
  protoOf(SizeModifierElement).d8y = function (node) {
    return this.uf2(node instanceof SizeModifierNode ? node : THROW_CCE());
  };
  function SizeModifierNode(sizeAnimation, sizeTransform, scope) {
    LayoutModifierNodeWithPassThroughIntrinsics.call(this);
    this.lf2_1 = sizeAnimation;
    this.mf2_1 = sizeTransform;
    this.nf2_1 = scope;
    this.of2_1 = get_UnspecifiedSize();
  }
  protoOf(SizeModifierNode).k8w = function () {
    protoOf(LayoutModifierNodeWithPassThroughIntrinsics).k8w.call(this);
    this.of2_1 = get_UnspecifiedSize();
  };
  protoOf(SizeModifierNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var placeable = measurable.h8y(constraints);
    var measuredSize;
    if (_this__u8e3s4.jag()) {
      var tmp0 = placeable.i8y_1;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = placeable.j8y_1;
      var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      measuredSize = _IntSize___init__impl__emcjft(tmp$ret$1);
    } else if (this.lf2_1 == null) {
      var tmp0_0 = placeable.i8y_1;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2_0 = placeable.j8y_1;
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
      measuredSize = _IntSize___init__impl__emcjft(tmp$ret$3);
      var tmp = this;
      var tmp0_1 = placeable.i8y_1;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2_1 = placeable.j8y_1;
      var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0_1), 32), bitwiseAnd(fromInt(val2_1), new Long(-1, 0)));
      tmp.of2_1 = _IntSize___init__impl__emcjft(tmp$ret$5);
    } else {
      var tmp0_2 = placeable.i8y_1;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2_2 = placeable.j8y_1;
      var tmp$ret$7 = bitwiseOr(shiftLeft(fromInt(tmp0_2), 32), bitwiseAnd(fromInt(val2_2), new Long(-1, 0)));
      var currentSize = _IntSize___init__impl__emcjft(tmp$ret$7);
      var tmp_0 = ensureNotNull(this.lf2_1);
      var tmp_1 = AnimatedContentTransitionScopeImpl$SizeModifierNode$measure$lambda(this, currentSize);
      var size = tmp_0.ueq(tmp_1, AnimatedContentTransitionScopeImpl$SizeModifierNode$measure$lambda_0(this, currentSize));
      this.nf2_1.sf1_1 = size;
      measuredSize = size.u1().o5g_1;
      this.of2_1 = size.u1().o5g_1;
    }
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = measuredSize;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    var tmp_2 = convertToInt(shiftRight(value, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_1 = measuredSize;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
    var tmp_3 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    return _this__u8e3s4.n8y(tmp_2, tmp_3, VOID, AnimatedContentTransitionScopeImpl$SizeModifierNode$measure$lambda_1(this, placeable, measuredSize));
  };
  function AnimatedContentTransitionScopeImpl$_get_measuredSize_$ref_khb72m() {
    return constructCallableReference(function (p0) {
      return new IntSize(p0.jf3());
    }, 1, 0, 234);
  }
  function AnimatedContentTransitionScopeImpl$_set_measuredSize_$ref_8lt206() {
    return constructCallableReference(function (p0, p1) {
      p0.kf3(p1.o5g_1);
      return Unit_instance;
    }, 2, 0, 235);
  }
  function createSizeAnimationModifier$lambda($shouldAnimateSize$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('shouldAnimateSize', KMutableProperty0, true);
    return $shouldAnimateSize$delegate.u1();
  }
  function createSizeAnimationModifier$lambda_0($shouldAnimateSize$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('shouldAnimateSize', KMutableProperty0, true);
    $shouldAnimateSize$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function AnimatedContentTransitionScopeImpl(transition, contentAlignment, layoutDirection) {
    this.nf1_1 = transition;
    this.of1_1 = contentAlignment;
    this.pf1_1 = layoutDirection;
    this.qf1_1 = mutableStateOf(new IntSize(Companion_getInstance_2().n5g_1));
    this.rf1_1 = mutableScatterMapOf();
    this.sf1_1 = null;
  }
  protoOf(AnimatedContentTransitionScopeImpl).rep = function () {
    return this.nf1_1.yep().rep();
  };
  protoOf(AnimatedContentTransitionScopeImpl).o70 = function () {
    return this.nf1_1.yep().o70();
  };
  protoOf(AnimatedContentTransitionScopeImpl).lf3 = function (_this__u8e3s4, sizeTransform) {
    // Inline function 'kotlin.apply' call
    _this__u8e3s4.kf1_1 = sizeTransform;
    return _this__u8e3s4;
  };
  protoOf(AnimatedContentTransitionScopeImpl).kf3 = function (_set____db54di) {
    var tmp0 = this.qf1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = AnimatedContentTransitionScopeImpl$_get_measuredSize_$ref_khb72m();
    getPropertyCallableRef('measuredSize', 1, tmp, tmp_0, AnimatedContentTransitionScopeImpl$_set_measuredSize_$ref_8lt206());
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new IntSize(_set____db54di);
    tmp0.s21(value);
    return Unit_instance;
  };
  protoOf(AnimatedContentTransitionScopeImpl).jf3 = function () {
    var tmp0 = this.qf1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = AnimatedContentTransitionScopeImpl$_get_measuredSize_$ref_khb72m();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('measuredSize', 1, tmp, tmp_0, AnimatedContentTransitionScopeImpl$_set_measuredSize_$ref_8lt206());
    return tmp0.u1().o5g_1;
  };
  protoOf(AnimatedContentTransitionScopeImpl).tf1 = function (contentTransform, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.k31(this);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = mutableStateOf(false);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var shouldAnimateSize$delegate = tmp;
    var sizeTransform = rememberUpdatedState(contentTransform.kf1_1, $composer_0, 0);
    if (equals(this.nf1_1.v70(), this.nf1_1.o70())) {
      createSizeAnimationModifier$lambda_0(shouldAnimateSize$delegate, false);
    } else {
      if (!(sizeTransform.u1() == null)) {
        createSizeAnimationModifier$lambda_0(shouldAnimateSize$delegate, true);
      }
    }
    var sizeAnimation;
    var tmp_0;
    if (createSizeAnimationModifier$lambda(shouldAnimateSize$delegate)) {
      $composer_0.m30(1353077497);
      var tmp_1 = get_VectorConverter(Companion_getInstance_2());
      sizeAnimation = createDeferredAnimation(this.nf1_1, tmp_1, null, $composer_0, 0, 2);
      var tmp1_remember$arg$0 = sizeAnimation;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_0.k31(tmp1_remember$arg$0);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_0.i31();
      var tmp_2;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var tmp_3;
        var tmp0_safe_receiver = sizeTransform.u1();
        if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.mf3()) === false) {
          tmp_3 = Companion_instance;
        } else {
          tmp_3 = clipToBounds(Companion_instance);
        }
        var value_0 = tmp_3;
        $composer_0.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp2_group = tmp_2;
      $composer_0.n30();
      tmp_0 = tmp2_group;
    } else {
      $composer_0.m30(1353343539);
      $composer_0.n30();
      sizeAnimation = null;
      this.sf1_1 = null;
      tmp_0 = Companion_instance;
    }
    return tmp_0.d8v(new SizeModifierElement(sizeAnimation, sizeTransform, this));
  };
  function AnimatedContentScopeImpl(animatedVisibilityScope) {
    this.nf3_1 = animatedVisibilityScope;
  }
  function AnimatedContentMeasurePolicy$measure$lambda($placeables, this$0, $maxWidth, $maxHeight) {
    return function ($this$layout) {
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = $placeables;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp = this$0.of3_1.of1_1;
          var tmp0 = element.i8y_1;
          // Inline function 'androidx.compose.ui.unit.IntSize' call
          // Inline function 'androidx.compose.ui.util.packInts' call
          var val2 = element.j8y_1;
          var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
          var tmp_0 = _IntSize___init__impl__emcjft(tmp$ret$5);
          var tmp0_0 = $maxWidth;
          // Inline function 'androidx.compose.ui.unit.IntSize' call
          // Inline function 'androidx.compose.ui.util.packInts' call
          var val2_0 = $maxHeight;
          var tmp$ret$7 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
          var tmp$ret$6 = _IntSize___init__impl__emcjft(tmp$ret$7);
          var offset = tmp.f8u(tmp_0, tmp$ret$6, LayoutDirection_Ltr_getInstance());
          $this$layout.jal(element, _IntOffset___get_x__impl__qiqr5o(offset), _IntOffset___get_y__impl__2avpwj(offset));
        }
      }
      return Unit_instance;
    };
  }
  function AnimatedContentMeasurePolicy(rootScope) {
    this.of3_1 = rootScope;
  }
  protoOf(AnimatedContentMeasurePolicy).mak = function (_this__u8e3s4, measurables, constraints) {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = measurables.n1();
    var placeables = Array(size);
    var targetSize = Companion_getInstance_2().n5g_1;
    // Inline function 'androidx.compose.ui.util.fastForEachIndexed' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        var tmp = item.xag();
        var tmp0_safe_receiver = tmp instanceof ChildData ? tmp : null;
        if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vf1()) === true) {
          // Inline function 'kotlin.also' call
          var this_0 = item.h8y(constraints);
          var tmp0 = this_0.i8y_1;
          // Inline function 'androidx.compose.ui.unit.IntSize' call
          // Inline function 'androidx.compose.ui.util.packInts' call
          var val2 = this_0.j8y_1;
          var tmp$ret$6 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
          targetSize = _IntSize___init__impl__emcjft(tmp$ret$6);
          placeables[index] = this_0;
        }
      }
       while (inductionVariable <= last);
    // Inline function 'androidx.compose.ui.util.fastForEachIndexed' call
    var inductionVariable_0 = 0;
    var last_0 = measurables.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = measurables.l1(index_0);
        if (placeables[index_0] == null) {
          placeables[index_0] = item_0.h8y(constraints);
        }
      }
       while (inductionVariable_0 <= last_0);
    var tmp_0;
    if (_this__u8e3s4.jag()) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = targetSize;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_1);
      tmp_0 = convertToInt(shiftRight(value, 32));
    } else {
      var tmp$ret$11;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        // Inline function 'kotlin.collections.isEmpty' call
        if (placeables.length === 0) {
          tmp$ret$11 = null;
          break $l$block_0;
        }
        var maxElem = placeables[0];
        var lastIndex = get_lastIndex(placeables);
        if (lastIndex === 0) {
          tmp$ret$11 = maxElem;
          break $l$block_0;
        }
        var tmp0_safe_receiver_0 = maxElem;
        var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.i8y_1;
        var maxValue = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        var inductionVariable_1 = 1;
        if (inductionVariable_1 <= lastIndex)
          do {
            var i = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var e = placeables[i];
            var tmp1_elvis_lhs_0 = e == null ? null : e.i8y_1;
            var v = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
            if (compareTo(maxValue, v) < 0) {
              maxElem = e;
              maxValue = v;
            }
          }
           while (!(i === lastIndex));
        tmp$ret$11 = maxElem;
      }
      var tmp0_safe_receiver_1 = tmp$ret$11;
      var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.i8y_1;
      tmp_0 = tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1;
    }
    var maxWidth = tmp_0;
    var tmp_1;
    if (_this__u8e3s4.jag()) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_2 = targetSize;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_2);
      tmp_1 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    } else {
      var tmp$ret$17;
      $l$block_2: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        // Inline function 'kotlin.collections.isEmpty' call
        if (placeables.length === 0) {
          tmp$ret$17 = null;
          break $l$block_2;
        }
        var maxElem_0 = placeables[0];
        var lastIndex_0 = get_lastIndex(placeables);
        if (lastIndex_0 === 0) {
          tmp$ret$17 = maxElem_0;
          break $l$block_2;
        }
        var tmp0_safe_receiver_2 = maxElem_0;
        var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.j8y_1;
        var maxValue_0 = tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2;
        var inductionVariable_2 = 1;
        if (inductionVariable_2 <= lastIndex_0)
          do {
            var i_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var e_0 = placeables[i_0];
            var tmp1_elvis_lhs_3 = e_0 == null ? null : e_0.j8y_1;
            var v_0 = tmp1_elvis_lhs_3 == null ? 0 : tmp1_elvis_lhs_3;
            if (compareTo(maxValue_0, v_0) < 0) {
              maxElem_0 = e_0;
              maxValue_0 = v_0;
            }
          }
           while (!(i_0 === lastIndex_0));
        tmp$ret$17 = maxElem_0;
      }
      var tmp2_safe_receiver = tmp$ret$17;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.j8y_1;
      tmp_1 = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    }
    var maxHeight = tmp_1;
    if (!_this__u8e3s4.jag()) {
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var tmp$ret$22 = bitwiseOr(shiftLeft(fromInt(maxWidth), 32), bitwiseAnd(fromInt(maxHeight), new Long(-1, 0)));
      var tmp$ret$21 = _IntSize___init__impl__emcjft(tmp$ret$22);
      this.of3_1.kf3(tmp$ret$21);
    }
    return _this__u8e3s4.n8y(maxWidth, maxHeight, VOID, AnimatedContentMeasurePolicy$measure$lambda(placeables, this, maxWidth, maxHeight));
  };
  protoOf(AnimatedContentMeasurePolicy).nak = function (_this__u8e3s4, measurables, height) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastMaxOfOrNull' call
      if (measurables.r()) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var maxValue = measurables.l1(0).b98(height);
      var inductionVariable = 1;
      var last = get_lastIndex_0(measurables);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var v = measurables.l1(i).b98(height);
          if (compareTo(v, maxValue) > 0)
            maxValue = v;
        }
         while (!(i === last));
      tmp$ret$0 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  };
  protoOf(AnimatedContentMeasurePolicy).oak = function (_this__u8e3s4, measurables, width) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastMaxOfOrNull' call
      if (measurables.r()) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var maxValue = measurables.l1(0).d98(width);
      var inductionVariable = 1;
      var last = get_lastIndex_0(measurables);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var v = measurables.l1(i).d98(width);
          if (compareTo(v, maxValue) > 0)
            maxValue = v;
        }
         while (!(i === last));
      tmp$ret$0 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  };
  protoOf(AnimatedContentMeasurePolicy).pak = function (_this__u8e3s4, measurables, height) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastMaxOfOrNull' call
      if (measurables.r()) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var maxValue = measurables.l1(0).c98(height);
      var inductionVariable = 1;
      var last = get_lastIndex_0(measurables);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var v = measurables.l1(i).c98(height);
          if (compareTo(v, maxValue) > 0)
            maxValue = v;
        }
         while (!(i === last));
      tmp$ret$0 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  };
  protoOf(AnimatedContentMeasurePolicy).qak = function (_this__u8e3s4, measurables, width) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastMaxOfOrNull' call
      if (measurables.r()) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var maxValue = measurables.l1(0).e98(width);
      var inductionVariable = 1;
      var last = get_lastIndex_0(measurables);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var v = measurables.l1(i).e98(width);
          if (compareTo(v, maxValue) > 0)
            maxValue = v;
        }
         while (!(i === last));
      tmp$ret$0 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  };
  function SizeTransformImpl(clip, sizeAnimationSpec) {
    clip = clip === VOID ? true : clip;
    this.pf3_1 = clip;
    this.qf3_1 = sizeAnimationSpec;
  }
  protoOf(SizeTransformImpl).mf3 = function () {
    return this.pf3_1;
  };
  protoOf(SizeTransformImpl).pf2 = function (initialSize, targetSize) {
    return this.qf3_1(new IntSize(initialSize), new IntSize(targetSize));
  };
  function AnimatedContent$lambda(_this__u8e3s4) {
    _init_properties_AnimatedContent_kt__n7dixw();
    var tmp = fadeIn(tween(220, 90));
    var tmp0_animationSpec = tween(220, 90);
    return togetherWith(tmp.rf3(scaleIn(tmp0_animationSpec, 0.92)), fadeOut(tween(90)));
  }
  function AnimatedContent$lambda_0(it) {
    _init_properties_AnimatedContent_kt__n7dixw();
    return it;
  }
  function AnimatedContent$lambda_1($targetState, $modifier, $transitionSpec, $contentAlignment, $label, $contentKey, $content, $$changed, $$default) {
    return function ($composer, $force) {
      AnimatedContent($targetState, $modifier._v, $transitionSpec._v, $contentAlignment._v, $label._v, $contentKey._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function AnimatedContent$lambda_2(_this__u8e3s4) {
    _init_properties_AnimatedContent_kt__n7dixw();
    var tmp = fadeIn(tween(220, 90));
    var tmp0_animationSpec = tween(220, 90);
    return togetherWith(tmp.rf3(scaleIn(tmp0_animationSpec, 0.92)), fadeOut(tween(90)));
  }
  function AnimatedContent$lambda_3(it) {
    _init_properties_AnimatedContent_kt__n7dixw();
    return it;
  }
  function AnimatedContent$lambda$lambda$lambda($placeable, $specOnEnter) {
    return function ($this$layout) {
      $this$layout.f8y($placeable, 0, 0, $specOnEnter.lf1());
      return Unit_instance;
    };
  }
  function AnimatedContent$lambda$lambda($specOnEnter) {
    return function ($this$layout, measurable, constraints) {
      var placeable = measurable.h8y(constraints.m5e_1);
      var tmp = placeable.i8y_1;
      var tmp_0 = placeable.j8y_1;
      return $this$layout.n8y(tmp, tmp_0, VOID, AnimatedContent$lambda$lambda$lambda(placeable, $specOnEnter));
    };
  }
  function AnimatedContent$lambda$lambda_0($stateForContent) {
    return function (it) {
      return equals(it, $stateForContent);
    };
  }
  function AnimatedContent$lambda$lambda_1($exit) {
    return function (currentState, targetState) {
      return currentState.equals(EnterExitState_PostExit_getInstance()) && targetState.equals(EnterExitState_PostExit_getInstance()) && !$exit.zf3().xf3_1;
    };
  }
  function AnimatedContent$$inlined$fastForEach$1$4$1$1($currentlyVisible, $stateForContent, $rootScope) {
    this.af4_1 = $currentlyVisible;
    this.bf4_1 = $stateForContent;
    this.cf4_1 = $rootScope;
  }
  protoOf(AnimatedContent$$inlined$fastForEach$1$4$1$1).s1d = function () {
    this.af4_1.g10(this.bf4_1);
    this.cf4_1.rf1_1.a3(this.bf4_1);
  };
  function AnimatedContent$lambda$lambda$lambda_0($currentlyVisible, $stateForContent, $rootScope) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new AnimatedContent$$inlined$fastForEach$1$4$1$1($currentlyVisible, $stateForContent, $rootScope);
    };
  }
  function AnimatedContent$lambda$lambda_2($currentlyVisible, $stateForContent, $rootScope, $content) {
    return function ($this$AnimatedEnterExitImpl, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31($this$AnimatedEnterExitImpl) : $composer_0.q31($this$AnimatedEnterExitImpl)) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.k31($currentlyVisible) | $composer_0.q31($stateForContent)) | $composer_0.q31($rootScope));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = AnimatedContent$lambda$lambda$lambda_0($currentlyVisible, $stateForContent, $rootScope);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$0 = tmp_1;
        DisposableEffect($this$AnimatedEnterExitImpl, tmp$ret$0, $composer_0, 14 & $dirty);
        $rootScope.rf1_1.h13($stateForContent, ($this$AnimatedEnterExitImpl instanceof AnimatedVisibilityScopeImpl ? $this$AnimatedEnterExitImpl : THROW_CCE()).ef4_1);
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_2;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = new AnimatedContentScopeImpl($this$AnimatedEnterExitImpl);
          $composer_0.j31(value_0);
          tmp_2 = value_0;
        } else {
          tmp_2 = it_0;
        }
        // Inline function 'kotlin.with' call
        var $this$with = tmp_2;
        $content($this$with, $stateForContent, $composer_0, 0);
        tmp_0 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function AnimatedContent$lambda_4($transitionSpec, $rootScope, $this_AnimatedContent, $stateForContent, $currentlyVisible, $content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = $transitionSpec._v($rootScope);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var specOnEnter = tmp_0;
        var tmp0_remember$arg$0 = equals($this_AnimatedContent.yep().o70(), $stateForContent);
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.l31(tmp0_remember$arg$0);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_1;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var tmp_2;
          if (equals($this_AnimatedContent.yep().o70(), $stateForContent)) {
            tmp_2 = Companion_getInstance_9().ff4_1;
          } else {
            tmp_2 = $transitionSpec._v($rootScope).if1_1;
          }
          var value_0 = tmp_2;
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_0;
        }
        var exit = tmp_1;
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_3;
        if (false || it_1 === Companion_getInstance().f30_1) {
          var value_1 = new ChildData(equals($stateForContent, $this_AnimatedContent.o70()));
          $composer_0.j31(value_1);
          tmp_3 = value_1;
        } else {
          tmp_3 = it_1;
        }
        var childData = tmp_3;
        var tmp0_enter = specOnEnter.hf1_1;
        var tmp_4 = Companion_instance;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31(specOnEnter);
        // Inline function 'kotlin.let' call
        var it_2 = $composer_0.i31();
        var tmp_5;
        if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
          var value_2 = AnimatedContent$lambda$lambda(specOnEnter);
          $composer_0.j31(value_2);
          tmp_5 = value_2;
        } else {
          tmp_5 = it_2;
        }
        var tmp$ret$12 = tmp_5;
        var tmp_6 = layout(tmp_4, tmp$ret$12);
        // Inline function 'kotlin.apply' call
        childData.wf1(equals($stateForContent, $this_AnimatedContent.o70()));
        var tmp1_modifier = tmp_6.d8v(childData);
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_0.q31($stateForContent);
        // Inline function 'kotlin.let' call
        var it_3 = $composer_0.i31();
        var tmp_7;
        if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = AnimatedContent$lambda$lambda_0($stateForContent);
          $composer_0.j31(value_3);
          tmp_7 = value_3;
        } else {
          tmp_7 = it_3;
        }
        var tmp_8 = tmp_7;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_0.k31(exit);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_0.i31();
        var tmp_9;
        if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = AnimatedContent$lambda$lambda_1(exit);
          $composer_0.j31(value_4);
          tmp_9 = value_4;
        } else {
          tmp_9 = it_4;
        }
        var tmp_10 = tmp_9;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-143346359, true, AnimatedContent$lambda$lambda_2($currentlyVisible, $stateForContent, $rootScope, $content), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_5 = $composer_1.i31();
        var tmp_11;
        if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
          var value_5 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value_5);
          tmp_11 = value_5;
        } else {
          tmp_11 = it_5;
        }
        var tmp$ret$26 = tmp_11;
        AnimatedEnterExitImpl($this_AnimatedContent, tmp_8, tmp1_modifier, tmp0_enter, exit, tmp_10, null, tmp$ret$26, $composer_0, 12582912, 64);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_0(p0) {
    return constructCallableReference(function (p0_0, p1) {
      p0.t50(p0_0, p1);
      return Unit_instance;
    }, 2, 0, 17, VOID, [p0]);
  }
  function AnimatedContent$lambda_5($this_AnimatedContent, $modifier, $transitionSpec, $contentAlignment, $contentKey, $content, $$changed, $$default) {
    return function ($composer, $force) {
      AnimatedContent_0($this_AnimatedContent, $modifier._v, $transitionSpec._v, $contentAlignment._v, $contentKey._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function SizeTransform$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
    _init_properties_AnimatedContent_kt__n7dixw();
    return spring(VOID, 400.0, new IntSize(get_VisibilityThreshold(Companion_getInstance_2())));
  }
  var properties_initialized_AnimatedContent_kt_39yooq;
  function _init_properties_AnimatedContent_kt__n7dixw() {
    if (!properties_initialized_AnimatedContent_kt_39yooq) {
      properties_initialized_AnimatedContent_kt_39yooq = true;
      var tmp0 = -2147483648;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = -2147483648;
      var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      UnspecifiedSize = _IntSize___init__impl__emcjft(tmp$ret$1);
      androidx_compose_animation_ContentTransform$stable = 8;
      androidx_compose_animation_AnimatedContentTransitionScopeImpl_ChildData$stable = 0;
      androidx_compose_animation_AnimatedContentTransitionScopeImpl$stable = 8;
    }
  }
  var androidx_compose_animation_AnimatedVisibilityScopeImpl$stable;
  var EnterExitState_PreEnter_instance;
  var EnterExitState_Visible_instance;
  var EnterExitState_PostExit_instance;
  var EnterExitState_entriesInitialized;
  function EnterExitState_initEntries() {
    if (EnterExitState_entriesInitialized)
      return Unit_instance;
    EnterExitState_entriesInitialized = true;
    EnterExitState_PreEnter_instance = new EnterExitState('PreEnter', 0);
    EnterExitState_Visible_instance = new EnterExitState('Visible', 1);
    EnterExitState_PostExit_instance = new EnterExitState('PostExit', 2);
  }
  function EnterExitState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function AnimatedVisibilityImpl(transition, visible, modifier, enter, exit, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1706321816);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(transition) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(visible) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(enter) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(exit) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74899) === 74898), $dirty & 1)) {
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(($dirty & 112) === 32 | ($dirty & 14) === 4);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = AnimatedVisibilityImpl$lambda(visible, transition);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$0 = tmp;
      var tmp_0 = layout(modifier, tmp$ret$0);
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_0.i31();
      var tmp_1;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = AnimatedVisibilityImpl$lambda_0;
        this_0.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp_2 = tmp_1;
      AnimatedEnterExitImpl(transition, visible, tmp_0, enter, exit, tmp_2, null, content, $composer_0, 196608 | 14 & $dirty | 112 & $dirty | 7168 & $dirty | 57344 & $dirty | 29360128 & $dirty << 6, 64);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(AnimatedVisibilityImpl$lambda_1(transition, visible, modifier, enter, exit, content, $changed));
    }
  }
  function AnimatedEnterExitImpl(transition, visible, modifier, enter, exit, shouldDisposeBlock, onLookaheadMeasured, content, $composer, $changed, $default) {
    var onLookaheadMeasured_0 = {_v: onLookaheadMeasured};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1912839215);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(transition) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(visible) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(enter) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(exit) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(shouldDisposeBlock) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ((($changed & 2097152) === 0 ? $composer_0.k31(onLookaheadMeasured_0._v) : $composer_0.q31(onLookaheadMeasured_0._v)) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 8388608 : 4194304);
    if ($composer_0.r31(!(($dirty & 4793491) === 4793490), $dirty & 1)) {
      if (!(($default & 64) === 0)) {
        onLookaheadMeasured_0._v = null;
      }
      if (visible(transition.o70()) || visible(transition.v70()) || transition.xep() || transition.ser()) {
        $composer_0.m30(-232386135);
        // Inline function 'androidx.compose.animation.core.createChildTransition' call
        var $changed_0 = 48 | 14 & $dirty;
        var label = 'EnterExitTransition';
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          label = 'ChildTransition';
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = ($changed_0 & 14 ^ 6) > 4 && $composer_1.k31(transition) || ($changed_0 & 6) === 4;
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = transition.v70();
          $composer_1.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var initialParentState = tmp;
        var tmp0 = transition.xep() ? transition.v70() : initialParentState;
        var $changed_1 = 112 & $changed_0 >> 3;
        var $composer_2 = $composer_1;
        $composer_2.m30(1844425648);
        var tmp0_0 = targetEnterExit(transition, visible, tmp0, $composer_2, 14 & $dirty | 112 & $dirty | 896 & $changed_1 << 6);
        $composer_2.n30();
        var initialState = tmp0_0;
        var tmp0_1 = transition.o70();
        var $changed_2 = 112 & $changed_0 >> 3;
        var $composer_3 = $composer_1;
        $composer_3.m30(1844425648);
        var tmp0_2 = targetEnterExit(transition, visible, tmp0_1, $composer_3, 14 & $dirty | 112 & $dirty | 896 & $changed_2 << 6);
        $composer_3.n30();
        var targetState = tmp0_2;
        var childTransition = createChildTransitionInternal(transition, initialState, targetState, label, $composer_1, 14 & $changed_0 | 7168 & $changed_0 << 6);
        var activeEnter = trackActiveEnter(childTransition, enter, $composer_0, 112 & $dirty >> 6);
        var activeExit = trackActiveExit(childTransition, exit, $composer_0, 112 & $dirty >> 9);
        var shouldDisposeBlockUpdated$delegate = rememberUpdatedState(shouldDisposeBlock, $composer_0, 14 & $dirty >> 15);
        var tmp_0 = shouldDisposeBlock(childTransition.v70(), childTransition.o70());
        var tmp0_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!($composer_0.k31(childTransition) | $composer_0.k31(shouldDisposeBlockUpdated$delegate));
        // Inline function 'kotlin.let' call
        var it_0 = tmp0_3.i31();
        var tmp_1;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = AnimatedEnterExitImpl$slambda_0(childTransition, shouldDisposeBlockUpdated$delegate, null);
          tmp0_3.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_0;
        }
        var tmp$ret$7 = tmp_1;
        var shouldDisposeAfterExit$delegate = produceState(tmp_0, tmp$ret$7, $composer_0, 0);
        if (!get_exitFinished(childTransition) || !AnimatedEnterExitImpl$lambda_0(shouldDisposeAfterExit$delegate)) {
          $composer_0.m30(-230699766);
          var tmp0_4 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_1 = ($dirty & 14) === 4;
          // Inline function 'kotlin.let' call
          var it_1 = tmp0_4.i31();
          var tmp_2;
          if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
            var value_1 = new AnimatedVisibilityScopeImpl(childTransition);
            tmp0_4.j31(value_1);
            tmp_2 = value_1;
          } else {
            tmp_2 = it_1;
          }
          var scope = tmp_2;
          var tmp_3 = createModifier(childTransition, activeEnter, activeExit, false, null, 'Built-in', $composer_0, 199680, 8);
          var tmp_4;
          if (!(onLookaheadMeasured_0._v == null)) {
            $composer_0.m30(-230087268);
            var tmp_5 = Companion_instance;
            var tmp0_5 = $composer_0;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_2 = ($dirty & 3670016) === 1048576 || (!(($dirty & 2097152) === 0) && $composer_0.q31(onLookaheadMeasured_0._v));
            // Inline function 'kotlin.let' call
            var it_2 = tmp0_5.i31();
            var tmp_6;
            if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
              var value_2 = AnimatedEnterExitImpl$lambda_1(onLookaheadMeasured_0);
              tmp0_5.j31(value_2);
              tmp_6 = value_2;
            } else {
              tmp_6 = it_2;
            }
            var tmp$ret$15 = tmp_6;
            var tmp0_group = layout(tmp_5, tmp$ret$15);
            $composer_0.n30();
            tmp_4 = tmp0_group;
          } else {
            $composer_0.m30(-7404393);
            $composer_0.n30();
            tmp_4 = Companion_instance;
          }
          var tmp0_6 = modifier.d8v(tmp_3.d8v(tmp_4));
          // Inline function 'androidx.compose.runtime.cache' call
          var this_0 = $composer_0;
          // Inline function 'kotlin.let' call
          var it_3 = this_0.i31();
          var tmp_7;
          if (false || it_3 === Companion_getInstance().f30_1) {
            var value_3 = new AnimatedEnterExitMeasurePolicy(scope);
            this_0.j31(value_3);
            tmp_7 = value_3;
          } else {
            tmp_7 = it_3;
          }
          var tmp2 = tmp_7;
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_0 = tmp0_6;
          var $composer_4 = $composer_0;
          if (!((0 & 2) === 0))
            modifier_0 = Companion_instance;
          var compositeKeyHash = get_currentCompositeKeyHashCode($composer_4, 0).hashCode();
          var localMap = $composer_4.t31();
          var materialized = materialize($composer_4, modifier_0);
          var tmp0_7 = Companion_getInstance_1().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_5 = $composer_4;
          var tmp_8 = $composer_5.g30();
          if (!isInterface(tmp_8, Applier)) {
            invalidApplier();
          }
          $composer_5.b31();
          if ($composer_5.h30()) {
            $composer_5.c31(tmp0_7);
          } else {
            $composer_5.d31();
          }
          var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_5);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp2, Companion_getInstance_1().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_1().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_1().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_1().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_1().qah_1);
          var $composer_6 = $composer_5;
          content(scope, $composer_6, 112 & $dirty >> 18);
          $composer_5.e31();
          $composer_0.n30();
        } else {
          $composer_0.m30(-229368781);
          $composer_0.n30();
        }
        $composer_0.n30();
      } else {
        $composer_0.m30(-229362829);
        $composer_0.n30();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(AnimatedEnterExitImpl$lambda_2(transition, visible, modifier, enter, exit, shouldDisposeBlock, onLookaheadMeasured_0, content, $changed, $default));
    }
  }
  function targetEnterExit(_this__u8e3s4, visible, targetState, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.o30(-422486745, _this__u8e3s4);
    var tmp;
    if (_this__u8e3s4.xep()) {
      $composer_0.m30(-212166497);
      $composer_0.n30();
      var tmp_0;
      if (visible(targetState)) {
        tmp_0 = EnterExitState_Visible_getInstance();
      } else {
        var tmp_1;
        if (visible(_this__u8e3s4.v70())) {
          tmp_1 = EnterExitState_PostExit_getInstance();
        } else {
          tmp_1 = EnterExitState_PreEnter_getInstance();
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      $composer_0.m30(-211892364);
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp_2;
      if (false || it === Companion_getInstance().f30_1) {
        var value = mutableStateOf(false);
        $composer_0.j31(value);
        tmp_2 = value;
      } else {
        tmp_2 = it;
      }
      var hasBeenVisible = tmp_2;
      if (visible(_this__u8e3s4.v70())) {
        hasBeenVisible.s21(true);
      }
      var tmp_3;
      if (visible(targetState)) {
        tmp_3 = EnterExitState_Visible_getInstance();
      } else {
        var tmp_4;
        if (hasBeenVisible.u1()) {
          tmp_4 = EnterExitState_PostExit_getInstance();
        } else {
          tmp_4 = EnterExitState_PreEnter_getInstance();
        }
        tmp_3 = tmp_4;
      }
      var tmp2_group = tmp_3;
      $composer_0.n30();
      tmp = tmp2_group;
    }
    var tmp1 = tmp;
    $composer_0.p30();
    return tmp1;
  }
  function get_exitFinished(_this__u8e3s4) {
    return _this__u8e3s4.v70().equals(EnterExitState_PostExit_getInstance()) && _this__u8e3s4.o70().equals(EnterExitState_PostExit_getInstance());
  }
  function AnimatedVisibilityScopeImpl(transition) {
    this.df4_1 = transition;
    this.ef4_1 = mutableStateOf(new IntSize(Companion_getInstance_2().n5g_1));
  }
  function AnimatedEnterExitMeasurePolicy$measure$lambda($placeables) {
    return function ($this$layout) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = $placeables;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          $this$layout.jal(item, 0, 0);
        }
         while (inductionVariable <= last);
      return Unit_instance;
    };
  }
  function AnimatedEnterExitMeasurePolicy(scope) {
    this.hf4_1 = scope;
    this.if4_1 = false;
  }
  protoOf(AnimatedEnterExitMeasurePolicy).mak = function (_this__u8e3s4, measurables, constraints) {
    var maxWidth = 0;
    var maxHeight = 0;
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        // Inline function 'kotlin.apply' call
        var this_0 = item.h8y(constraints);
        var tmp0 = maxWidth;
        // Inline function 'kotlin.math.max' call
        var b = this_0.i8y_1;
        maxWidth = Math.max(tmp0, b);
        var tmp0_0 = maxHeight;
        // Inline function 'kotlin.math.max' call
        var b_0 = this_0.j8y_1;
        maxHeight = Math.max(tmp0_0, b_0);
        // Inline function 'kotlin.collections.plusAssign' call
        target.j1(this_0);
      }
       while (inductionVariable <= last);
    var placeables = target;
    if (_this__u8e3s4.jag()) {
      this.if4_1 = true;
      var tmp0_1 = maxWidth;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = maxHeight;
      var tmp$ret$10 = bitwiseOr(shiftLeft(fromInt(tmp0_1), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$9 = _IntSize___init__impl__emcjft(tmp$ret$10);
      this.hf4_1.ef4_1.s21(new IntSize(tmp$ret$9));
    } else if (!this.if4_1) {
      var tmp0_2 = maxWidth;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2_0 = maxHeight;
      var tmp$ret$12 = bitwiseOr(shiftLeft(fromInt(tmp0_2), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
      var tmp$ret$11 = _IntSize___init__impl__emcjft(tmp$ret$12);
      this.hf4_1.ef4_1.s21(new IntSize(tmp$ret$11));
    }
    var tmp = maxWidth;
    var tmp_0 = maxHeight;
    return _this__u8e3s4.n8y(tmp, tmp_0, VOID, AnimatedEnterExitMeasurePolicy$measure$lambda(placeables));
  };
  protoOf(AnimatedEnterExitMeasurePolicy).nak = function (_this__u8e3s4, measurables, height) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastMaxOfOrDefault' call
      if (measurables.r()) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var maxValue = measurables.l1(0).b98(height);
      var inductionVariable = 1;
      var last = get_lastIndex_0(measurables);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var v = measurables.l1(i).b98(height);
          if (compareTo(v, maxValue) > 0)
            maxValue = v;
        }
         while (!(i === last));
      tmp$ret$0 = maxValue;
    }
    return tmp$ret$0;
  };
  protoOf(AnimatedEnterExitMeasurePolicy).oak = function (_this__u8e3s4, measurables, width) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastMaxOfOrDefault' call
      if (measurables.r()) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var maxValue = measurables.l1(0).d98(width);
      var inductionVariable = 1;
      var last = get_lastIndex_0(measurables);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var v = measurables.l1(i).d98(width);
          if (compareTo(v, maxValue) > 0)
            maxValue = v;
        }
         while (!(i === last));
      tmp$ret$0 = maxValue;
    }
    return tmp$ret$0;
  };
  protoOf(AnimatedEnterExitMeasurePolicy).pak = function (_this__u8e3s4, measurables, height) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastMaxOfOrDefault' call
      if (measurables.r()) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var maxValue = measurables.l1(0).c98(height);
      var inductionVariable = 1;
      var last = get_lastIndex_0(measurables);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var v = measurables.l1(i).c98(height);
          if (compareTo(v, maxValue) > 0)
            maxValue = v;
        }
         while (!(i === last));
      tmp$ret$0 = maxValue;
    }
    return tmp$ret$0;
  };
  protoOf(AnimatedEnterExitMeasurePolicy).qak = function (_this__u8e3s4, measurables, width) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastMaxOfOrDefault' call
      if (measurables.r()) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var maxValue = measurables.l1(0).e98(width);
      var inductionVariable = 1;
      var last = get_lastIndex_0(measurables);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var v = measurables.l1(i).e98(width);
          if (compareTo(v, maxValue) > 0)
            maxValue = v;
        }
         while (!(i === last));
      tmp$ret$0 = maxValue;
    }
    return tmp$ret$0;
  };
  function AnimatedVisibility(visible, modifier, enter, exit, label, content, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var enter_0 = {_v: enter};
    var exit_0 = {_v: exit};
    var label_0 = {_v: label};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1448730565);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.l31(visible) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(enter_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(exit_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(label_0._v) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74899) === 74898), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 4) === 0)) {
        enter_0._v = fadeIn().rf3(expandIn());
      }
      if (!(($default & 8) === 0)) {
        exit_0._v = shrinkOut().jf4(fadeOut());
      }
      if (!(($default & 16) === 0)) {
        label_0._v = 'AnimatedVisibility';
      }
      var transition = updateTransition(visible, label_0._v, $composer_0, 14 & $dirty | 112 & $dirty >> 9, 0);
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = AnimatedVisibility$lambda;
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$0 = tmp;
      AnimatedVisibilityImpl(transition, tmp$ret$0, modifier_0._v, enter_0._v, exit_0._v, content, $composer_0, 48 | 896 & $dirty << 3 | 7168 & $dirty << 3 | 57344 & $dirty << 3 | 458752 & $dirty);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(AnimatedVisibility$lambda_0(visible, modifier_0, enter_0, exit_0, label_0, content, $changed, $default));
    }
  }
  function AnimatedVisibilityImpl$lambda$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.jal($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function AnimatedVisibilityImpl$lambda($visible, $transition) {
    return function ($this$layout, measurable, constraints) {
      var placeable = measurable.h8y(constraints.m5e_1);
      var tmp;
      if ($this$layout.jag() && !$visible($transition.o70())) {
        tmp = Companion_getInstance_2().n5g_1;
      } else {
        var tmp0 = placeable.i8y_1;
        // Inline function 'androidx.compose.ui.unit.IntSize' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val2 = placeable.j8y_1;
        var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
        tmp = _IntSize___init__impl__emcjft(tmp$ret$1);
      }
      var _destruct__k2r9zo = tmp;
      // Inline function 'androidx.compose.ui.unit.IntSize.component1' call
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(_destruct__k2r9zo);
      var w = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.component2' call
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(_destruct__k2r9zo);
      var h = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      return $this$layout.n8y(w, h, VOID, AnimatedVisibilityImpl$lambda$lambda(placeable));
    };
  }
  function AnimatedVisibilityImpl$lambda_0(current, target) {
    return current.equals(target) && target.equals(EnterExitState_PostExit_getInstance());
  }
  function AnimatedVisibilityImpl$lambda_1($transition, $visible, $modifier, $enter, $exit, $content, $$changed) {
    return function ($composer, $force) {
      AnimatedVisibilityImpl($transition, $visible, $modifier, $enter, $exit, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function AnimatedEnterExitImpl$lambda($shouldDisposeBlockUpdated$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('shouldDisposeBlockUpdated', KProperty0, false);
    return $shouldDisposeBlockUpdated$delegate.u1();
  }
  function AnimatedEnterExitImpl$lambda_0($shouldDisposeAfterExit$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('shouldDisposeAfterExit', KProperty0, false);
    return $shouldDisposeAfterExit$delegate.u1();
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.kf4_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a1v = function (value, $completion) {
    return this.kf4_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).q3 = function () {
    return this.kf4_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function AnimatedEnterExitImpl$slambda$lambda($childTransition) {
    return function () {
      return get_exitFinished($childTransition);
    };
  }
  function AnimatedEnterExitImpl$slambda$slambda($this_produceState, $childTransition, $shouldDisposeBlockUpdated$delegate, resultContinuation) {
    this.tf4_1 = $this_produceState;
    this.uf4_1 = $childTransition;
    this.vf4_1 = $shouldDisposeBlockUpdated$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AnimatedEnterExitImpl$slambda$slambda).xf4 = function (it, $completion) {
    var tmp = this.yf4(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AnimatedEnterExitImpl$slambda$slambda).ja = function (p1, $completion) {
    return this.xf4((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AnimatedEnterExitImpl$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0;
          if (this.wf4_1) {
            tmp_0 = AnimatedEnterExitImpl$lambda(this.vf4_1)(this.uf4_1.v70(), this.uf4_1.o70());
          } else {
            tmp_0 = false;
          }
          this.tf4_1.s21(tmp_0);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(AnimatedEnterExitImpl$slambda$slambda).yf4 = function (it, completion) {
    var i = new AnimatedEnterExitImpl$slambda$slambda(this.tf4_1, this.uf4_1, this.vf4_1, completion);
    i.wf4_1 = it;
    return i;
  };
  function AnimatedEnterExitImpl$slambda$slambda_0($this_produceState, $childTransition, $shouldDisposeBlockUpdated$delegate, resultContinuation) {
    var i = new AnimatedEnterExitImpl$slambda$slambda($this_produceState, $childTransition, $shouldDisposeBlockUpdated$delegate, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.xf4(it, $completion);
    }, 1);
  }
  function AnimatedEnterExitImpl$slambda($childTransition, $shouldDisposeBlockUpdated$delegate, resultContinuation) {
    this.hf5_1 = $childTransition;
    this.if5_1 = $shouldDisposeBlockUpdated$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AnimatedEnterExitImpl$slambda).kf5 = function ($this$produceState, $completion) {
    var tmp = this.lf5($this$produceState, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AnimatedEnterExitImpl$slambda).ja = function (p1, $completion) {
    return this.kf5((!(p1 == null) ? isInterface(p1, ProduceStateScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AnimatedEnterExitImpl$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = snapshotFlow(AnimatedEnterExitImpl$slambda$lambda(this.hf5_1));
            var tmp_1 = AnimatedEnterExitImpl$slambda$slambda_0(this.jf5_1, this.hf5_1, this.if5_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AnimatedEnterExitImpl$slambda).lf5 = function ($this$produceState, completion) {
    var i = new AnimatedEnterExitImpl$slambda(this.hf5_1, this.if5_1, completion);
    i.jf5_1 = $this$produceState;
    return i;
  };
  function AnimatedEnterExitImpl$slambda_0($childTransition, $shouldDisposeBlockUpdated$delegate, resultContinuation) {
    var i = new AnimatedEnterExitImpl$slambda($childTransition, $shouldDisposeBlockUpdated$delegate, resultContinuation);
    return constructCallableReference(function ($this$produceState, $completion) {
      return i.kf5($this$produceState, $completion);
    }, 1);
  }
  function AnimatedEnterExitImpl$lambda$lambda($$this$run) {
    return function ($this$layout) {
      $this$layout.jal($$this$run, 0, 0);
      return Unit_instance;
    };
  }
  function AnimatedEnterExitImpl$lambda_1($onLookaheadMeasured) {
    return function ($this$layout, measurable, constraints) {
      // Inline function 'kotlin.run' call
      var $this$run = measurable.h8y(constraints.m5e_1);
      if ($this$layout.jag()) {
        var tmp = $onLookaheadMeasured._v;
        var tmp0 = $this$run.i8y_1;
        // Inline function 'androidx.compose.ui.unit.IntSize' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val2 = $this$run.j8y_1;
        var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
        var tmp$ret$2 = _IntSize___init__impl__emcjft(tmp$ret$3);
        tmp.mf5(tmp$ret$2);
      }
      var tmp_0 = $this$run.i8y_1;
      var tmp_1 = $this$run.j8y_1;
      return $this$layout.n8y(tmp_0, tmp_1, VOID, AnimatedEnterExitImpl$lambda$lambda($this$run));
    };
  }
  function AnimatedEnterExitImpl$lambda_2($transition, $visible, $modifier, $enter, $exit, $shouldDisposeBlock, $onLookaheadMeasured, $content, $$changed, $$default) {
    return function ($composer, $force) {
      AnimatedEnterExitImpl($transition, $visible, $modifier, $enter, $exit, $shouldDisposeBlock, $onLookaheadMeasured._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function AnimatedVisibility$lambda(it) {
    return it;
  }
  function AnimatedVisibility$lambda_0($visible, $modifier, $enter, $exit, $label, $content, $$changed, $$default) {
    return function ($composer, $force) {
      AnimatedVisibility($visible, $modifier._v, $enter._v, $exit._v, $label._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function EnterExitState_PreEnter_getInstance() {
    EnterExitState_initEntries();
    return EnterExitState_PreEnter_instance;
  }
  function EnterExitState_Visible_getInstance() {
    EnterExitState_initEntries();
    return EnterExitState_Visible_instance;
  }
  function EnterExitState_PostExit_getInstance() {
    EnterExitState_initEntries();
    return EnterExitState_PostExit_instance;
  }
  function get_InvalidSize() {
    _init_properties_AnimationModifier_kt__u6vzef();
    return InvalidSize;
  }
  var InvalidSize;
  var androidx_compose_animation_SizeAnimationModifierNode_AnimData$stable;
  var androidx_compose_animation_LayoutModifierNodeWithPassThroughIntrinsics$stable;
  function LayoutModifierNodeWithPassThroughIntrinsics() {
    Node.call(this);
  }
  protoOf(LayoutModifierNodeWithPassThroughIntrinsics).o8y = function (_this__u8e3s4, measurable, height) {
    return measurable.b98(height);
  };
  protoOf(LayoutModifierNodeWithPassThroughIntrinsics).p8y = function (_this__u8e3s4, measurable, width) {
    return measurable.d98(width);
  };
  protoOf(LayoutModifierNodeWithPassThroughIntrinsics).q8y = function (_this__u8e3s4, measurable, height) {
    return measurable.c98(height);
  };
  protoOf(LayoutModifierNodeWithPassThroughIntrinsics).r8y = function (_this__u8e3s4, measurable, width) {
    return measurable.e98(width);
  };
  function get_isValid(_this__u8e3s4) {
    _init_properties_AnimationModifier_kt__u6vzef();
    return !equals(_this__u8e3s4, get_InvalidSize());
  }
  var properties_initialized_AnimationModifier_kt_fvv7xx;
  function _init_properties_AnimationModifier_kt__u6vzef() {
    if (!properties_initialized_AnimationModifier_kt_fvv7xx) {
      properties_initialized_AnimationModifier_kt_fvv7xx = true;
      var tmp0 = -2147483648;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = -2147483648;
      var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      InvalidSize = _IntSize___init__impl__emcjft(tmp$ret$1);
      androidx_compose_animation_SizeAnimationModifierNode_AnimData$stable = 8;
      androidx_compose_animation_LayoutModifierNodeWithPassThroughIntrinsics$stable = androidx_compose_ui_Modifier_Node$stableprop_getter();
    }
  }
  function get_ColorToVector() {
    _init_properties_ColorVectorConverter_kt__qncuxy();
    return ColorToVector;
  }
  var ColorToVector;
  function get_VectorConverter_2(_this__u8e3s4) {
    _init_properties_ColorVectorConverter_kt__qncuxy();
    return get_ColorToVector();
  }
  function ColorToVector$lambda(colorSpace) {
    _init_properties_ColorVectorConverter_kt__qncuxy();
    var tmp = ColorToVector$lambda$lambda;
    return TwoWayConverter(tmp, ColorToVector$lambda$lambda_0(colorSpace));
  }
  function ColorToVector$lambda$lambda(color) {
    _init_properties_ColorVectorConverter_kt__qncuxy();
    var _destruct__k2r9zo = Color__convert_impl_so5m8t(color.c6d_1, ColorSpaces_getInstance().p6f_1);
    // Inline function 'androidx.compose.ui.graphics.Color.component1' call
    var l = _Color___get_red__impl__cwrsk6(_destruct__k2r9zo);
    // Inline function 'androidx.compose.ui.graphics.Color.component2' call
    var a = _Color___get_green__impl__bta9rs(_destruct__k2r9zo);
    // Inline function 'androidx.compose.ui.graphics.Color.component3' call
    var b = _Color___get_blue__impl__xwez13(_destruct__k2r9zo);
    // Inline function 'androidx.compose.ui.graphics.Color.component4' call
    var alpha = _Color___get_alpha__impl__wcfyv1(_destruct__k2r9zo);
    return new AnimationVector4D(alpha, l, a, b);
  }
  function ColorToVector$lambda$lambda_0($colorSpace) {
    return function (vector) {
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var this_0 = vector.meg_1;
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_1 = this_0 < 0.0 ? 0.0 : this_0;
      var tmp = this_1 > 1.0 ? 1.0 : this_1;
      var tmp0 = vector.neg_1;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var minimumValue = -0.5;
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_2 = tmp0 < minimumValue ? minimumValue : tmp0;
      var tmp_0 = this_2 > 0.5 ? 0.5 : this_2;
      var tmp0_0 = vector.oeg_1;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var minimumValue_0 = -0.5;
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_3 = tmp0_0 < minimumValue_0 ? minimumValue_0 : tmp0_0;
      var tmp_1 = this_3 > 0.5 ? 0.5 : this_3;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var this_4 = vector.leg_1;
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_5 = this_4 < 0.0 ? 0.0 : this_4;
      var tmp$ret$9 = this_5 > 1.0 ? 1.0 : this_5;
      return new Color_0(Color__convert_impl_so5m8t(Color(tmp, tmp_0, tmp_1, tmp$ret$9, ColorSpaces_getInstance().p6f_1), $colorSpace));
    };
  }
  var properties_initialized_ColorVectorConverter_kt_jaoojo;
  function _init_properties_ColorVectorConverter_kt__qncuxy() {
    if (!properties_initialized_ColorVectorConverter_kt_jaoojo) {
      properties_initialized_ColorVectorConverter_kt_jaoojo = true;
      ColorToVector = ColorToVector$lambda;
    }
  }
  function get_TransformOriginVectorConverter() {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return TransformOriginVectorConverter;
  }
  var TransformOriginVectorConverter;
  function get_DefaultAlphaAndScaleSpring() {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return DefaultAlphaAndScaleSpring;
  }
  var DefaultAlphaAndScaleSpring;
  function get_DefaultColorAnimationSpec() {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return DefaultColorAnimationSpec;
  }
  var DefaultColorAnimationSpec;
  function get_DefaultOffsetAnimationSpec() {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return DefaultOffsetAnimationSpec;
  }
  var DefaultOffsetAnimationSpec;
  function get_DefaultSizeAnimationSpec() {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return DefaultSizeAnimationSpec;
  }
  var DefaultSizeAnimationSpec;
  var androidx_compose_animation_EnterTransition$stable;
  var androidx_compose_animation_ExitTransition$stable;
  var androidx_compose_animation_TransitionEffect$stable;
  var androidx_compose_animation_ContentScaleTransitionEffect$stable;
  var androidx_compose_animation_Fade$stable;
  var androidx_compose_animation_Slide$stable;
  var androidx_compose_animation_ChangeSize$stable;
  var androidx_compose_animation_Scale$stable;
  var androidx_compose_animation_Veil$stable;
  var androidx_compose_animation_TransitionData$stable;
  function Companion() {
    Companion_instance_0 = this;
    this.nf5_1 = new EnterTransitionImpl(new TransitionData());
  }
  var Companion_instance_0;
  function Companion_getInstance_8() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function EnterTransition() {
    Companion_getInstance_8();
  }
  protoOf(EnterTransition).rf3 = function (enter) {
    var tmp0_elvis_lhs = enter.zf3().sf3_1;
    var tmp = tmp0_elvis_lhs == null ? this.zf3().sf3_1 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = enter.zf3().tf3_1;
    var tmp_0 = tmp1_elvis_lhs == null ? this.zf3().tf3_1 : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = enter.zf3().uf3_1;
    var tmp_1 = tmp2_elvis_lhs == null ? this.zf3().uf3_1 : tmp2_elvis_lhs;
    var tmp3_elvis_lhs = enter.zf3().vf3_1;
    var tmp_2 = tmp3_elvis_lhs == null ? this.zf3().vf3_1 : tmp3_elvis_lhs;
    var tmp4_elvis_lhs = enter.zf3().wf3_1;
    return new EnterTransitionImpl(new TransitionData(tmp, tmp_0, tmp_1, tmp_2, tmp4_elvis_lhs == null ? this.zf3().wf3_1 : tmp4_elvis_lhs, VOID, plus(this.zf3().yf3_1, enter.zf3().yf3_1)));
  };
  protoOf(EnterTransition).toString = function () {
    var tmp;
    if (this.equals(Companion_getInstance_8().nf5_1)) {
      tmp = 'EnterTransition.None';
    } else {
      // Inline function 'kotlin.run' call
      var $this$run = this.zf3();
      var tmp0_safe_receiver = $this$run.sf3_1;
      var tmp_0 = 'EnterTransition: \nFade - ' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString()) + ',\nSlide - ';
      var tmp1_safe_receiver = $this$run.tf3_1;
      var tmp_1 = tmp_0 + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString()) + ',\nShrink - ';
      var tmp2_safe_receiver = $this$run.uf3_1;
      var tmp_2 = tmp_1 + (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.toString()) + ',\nScale - ';
      var tmp3_safe_receiver = $this$run.vf3_1;
      tmp = tmp_2 + (tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString());
    }
    return tmp;
  };
  protoOf(EnterTransition).equals = function (other) {
    var tmp;
    if (other instanceof EnterTransition) {
      tmp = other.zf3().equals(this.zf3());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EnterTransition).hashCode = function () {
    return this.zf3().hashCode();
  };
  function Companion_0() {
    Companion_instance_1 = this;
    this.ff4_1 = new ExitTransitionImpl(new TransitionData());
    this.gf4_1 = new ExitTransitionImpl(new TransitionData(VOID, VOID, VOID, VOID, VOID, true));
  }
  var Companion_instance_1;
  function Companion_getInstance_9() {
    if (Companion_instance_1 == null)
      new Companion_0();
    return Companion_instance_1;
  }
  function ExitTransition() {
    Companion_getInstance_9();
  }
  protoOf(ExitTransition).jf4 = function (exit) {
    var tmp0_elvis_lhs = exit.zf3().sf3_1;
    var tmp = tmp0_elvis_lhs == null ? this.zf3().sf3_1 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = exit.zf3().tf3_1;
    var tmp_0 = tmp1_elvis_lhs == null ? this.zf3().tf3_1 : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = exit.zf3().uf3_1;
    var tmp_1 = tmp2_elvis_lhs == null ? this.zf3().uf3_1 : tmp2_elvis_lhs;
    var tmp3_elvis_lhs = exit.zf3().vf3_1;
    var tmp_2 = tmp3_elvis_lhs == null ? this.zf3().vf3_1 : tmp3_elvis_lhs;
    var tmp4_elvis_lhs = exit.zf3().wf3_1;
    return new ExitTransitionImpl(new TransitionData(tmp, tmp_0, tmp_1, tmp_2, tmp4_elvis_lhs == null ? this.zf3().wf3_1 : tmp4_elvis_lhs, exit.zf3().xf3_1 || this.zf3().xf3_1, plus(this.zf3().yf3_1, exit.zf3().yf3_1)));
  };
  protoOf(ExitTransition).equals = function (other) {
    var tmp;
    if (other instanceof ExitTransition) {
      tmp = other.zf3().equals(this.zf3());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ExitTransition).toString = function () {
    var tmp;
    if (this.equals(Companion_getInstance_9().ff4_1)) {
      tmp = 'ExitTransition.None';
    } else if (this.equals(Companion_getInstance_9().gf4_1)) {
      tmp = 'ExitTransition.KeepUntilTransitionsFinished';
    } else {
      // Inline function 'kotlin.run' call
      var $this$run = this.zf3();
      var tmp0_safe_receiver = $this$run.sf3_1;
      var tmp_0 = 'ExitTransition: \nFade - ' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString()) + ',\nSlide - ';
      var tmp1_safe_receiver = $this$run.tf3_1;
      var tmp_1 = tmp_0 + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString()) + ',\nShrink - ';
      var tmp2_safe_receiver = $this$run.uf3_1;
      var tmp_2 = tmp_1 + (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.toString()) + ',\nScale - ';
      var tmp3_safe_receiver = $this$run.vf3_1;
      tmp = tmp_2 + (tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString()) + ',\nKeepUntilTransitionsFinished - ' + $this$run.xf3_1;
    }
    return tmp;
  };
  protoOf(ExitTransition).hashCode = function () {
    return this.zf3().hashCode();
  };
  function fadeIn(animationSpec, initialAlpha) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0) : animationSpec;
    initialAlpha = initialAlpha === VOID ? 0.0 : initialAlpha;
    _init_properties_EnterExitTransition_kt__2obrqf();
    return new EnterTransitionImpl(new TransitionData(new Fade(initialAlpha, animationSpec)));
  }
  function expandVertically(animationSpec, expandFrom, clip, initialHeight) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0, new IntSize(get_VisibilityThreshold(Companion_getInstance_2()))) : animationSpec;
    expandFrom = expandFrom === VOID ? Companion_getInstance_0().v8t_1 : expandFrom;
    clip = clip === VOID ? true : clip;
    var tmp;
    if (initialHeight === VOID) {
      tmp = expandVertically$lambda;
    } else {
      tmp = initialHeight;
    }
    initialHeight = tmp;
    _init_properties_EnterExitTransition_kt__2obrqf();
    var tmp_0 = toAlignment(expandFrom);
    return expandIn(animationSpec, tmp_0, clip, expandVertically$lambda_0(initialHeight));
  }
  function fadeOut(animationSpec, targetAlpha) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0) : animationSpec;
    targetAlpha = targetAlpha === VOID ? 0.0 : targetAlpha;
    _init_properties_EnterExitTransition_kt__2obrqf();
    return new ExitTransitionImpl(new TransitionData(new Fade(targetAlpha, animationSpec)));
  }
  function shrinkVertically(animationSpec, shrinkTowards, clip, targetHeight) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0, new IntSize(get_VisibilityThreshold(Companion_getInstance_2()))) : animationSpec;
    shrinkTowards = shrinkTowards === VOID ? Companion_getInstance_0().v8t_1 : shrinkTowards;
    clip = clip === VOID ? true : clip;
    var tmp;
    if (targetHeight === VOID) {
      tmp = shrinkVertically$lambda;
    } else {
      tmp = targetHeight;
    }
    targetHeight = tmp;
    _init_properties_EnterExitTransition_kt__2obrqf();
    var tmp_0 = toAlignment(shrinkTowards);
    return shrinkOut(animationSpec, tmp_0, clip, shrinkVertically$lambda_0(targetHeight));
  }
  function expandIn(animationSpec, expandFrom, clip, initialSize) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0, new IntSize(get_VisibilityThreshold(Companion_getInstance_2()))) : animationSpec;
    expandFrom = expandFrom === VOID ? Companion_getInstance_0().s8t_1 : expandFrom;
    clip = clip === VOID ? true : clip;
    var tmp;
    if (initialSize === VOID) {
      tmp = expandIn$lambda;
    } else {
      tmp = initialSize;
    }
    initialSize = tmp;
    _init_properties_EnterExitTransition_kt__2obrqf();
    return new EnterTransitionImpl(new TransitionData(VOID, VOID, new ChangeSize(expandFrom, initialSize, animationSpec, clip)));
  }
  function shrinkOut(animationSpec, shrinkTowards, clip, targetSize) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0, new IntSize(get_VisibilityThreshold(Companion_getInstance_2()))) : animationSpec;
    shrinkTowards = shrinkTowards === VOID ? Companion_getInstance_0().s8t_1 : shrinkTowards;
    clip = clip === VOID ? true : clip;
    var tmp;
    if (targetSize === VOID) {
      tmp = shrinkOut$lambda;
    } else {
      tmp = targetSize;
    }
    targetSize = tmp;
    _init_properties_EnterExitTransition_kt__2obrqf();
    return new ExitTransitionImpl(new TransitionData(VOID, VOID, new ChangeSize(shrinkTowards, targetSize, animationSpec, clip)));
  }
  function createModifier(_this__u8e3s4, enter, exit, trackActiveEnterExit, isEnabled, label, $composer, $changed, $default) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    var trackActiveEnterExit_0 = trackActiveEnterExit;
    var isEnabled_0 = {_v: isEnabled};
    var $composer_0 = $composer;
    if (!(($default & 4) === 0))
      trackActiveEnterExit_0 = true;
    if (!(($default & 8) === 0)) {
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = createModifier$lambda;
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      isEnabled_0._v = tmp;
    }
    var tmp_0;
    if (trackActiveEnterExit_0) {
      $composer_0.m30(-167965831);
      var tmp1_group = trackActiveEnter(_this__u8e3s4, enter, $composer_0, 14 & $changed | 112 & $changed);
      $composer_0.n30();
      tmp_0 = tmp1_group;
    } else {
      $composer_0.m30(-167964673);
      $composer_0.n30();
      tmp_0 = enter;
    }
    var activeEnter = tmp_0;
    var tmp_1;
    if (trackActiveEnterExit_0) {
      $composer_0.m30(-167962954);
      var tmp2_group = trackActiveExit(_this__u8e3s4, exit, $composer_0, 14 & $changed | 112 & $changed >> 3);
      $composer_0.n30();
      tmp_1 = tmp2_group;
    } else {
      $composer_0.m30(-167961890);
      $composer_0.n30();
      tmp_1 = exit;
    }
    var activeExit = tmp_1;
    var shouldAnimateVeil = !(activeEnter.zf3().wf3_1 == null) || !(activeExit.zf3().wf3_1 == null);
    var shouldAnimateSlide = !(activeEnter.zf3().tf3_1 == null) || !(activeExit.zf3().tf3_1 == null);
    var shouldAnimateSizeChange = !(activeEnter.zf3().uf3_1 == null) || !(activeExit.zf3().uf3_1 == null);
    var tmp_2;
    if (shouldAnimateSlide) {
      $composer_0.m30(-911488127);
      var tmp_3 = get_VectorConverter_0(Companion_getInstance_3());
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_0 = $composer_0.i31();
      var tmp_4;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = label + ' slide';
        $composer_0.j31(value_0);
        tmp_4 = value_0;
      } else {
        tmp_4 = it_0;
      }
      var tmp$ret$4 = tmp_4;
      var tmp3_group = createDeferredAnimation(_this__u8e3s4, tmp_3, tmp$ret$4, $composer_0, 384 | 14 & $changed, 0);
      $composer_0.n30();
      tmp_2 = tmp3_group;
    } else {
      $composer_0.m30(-911382324);
      $composer_0.n30();
      tmp_2 = null;
    }
    var slideAnimation = tmp_2;
    var tmp_5;
    if (shouldAnimateSizeChange) {
      $composer_0.m30(-911290533);
      var tmp_6 = get_VectorConverter(Companion_getInstance_2());
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_1 = $composer_0.i31();
      var tmp_7;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = label + ' shrink/expand';
        $composer_0.j31(value_1);
        tmp_7 = value_1;
      } else {
        tmp_7 = it_1;
      }
      var tmp$ret$8 = tmp_7;
      var tmp4_group = createDeferredAnimation(_this__u8e3s4, tmp_6, tmp$ret$8, $composer_0, 384 | 14 & $changed, 0);
      $composer_0.n30();
      tmp_5 = tmp4_group;
    } else {
      $composer_0.m30(-911179709);
      $composer_0.n30();
      tmp_5 = null;
    }
    var sizeAnimation = tmp_5;
    var tmp_8;
    if (shouldAnimateSizeChange) {
      $composer_0.m30(-911106083);
      var tmp_9 = get_VectorConverter_0(Companion_getInstance_3());
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_2 = $composer_0.i31();
      var tmp_10;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = label + ' InterruptionHandlingOffset';
        $composer_0.j31(value_2);
        tmp_10 = value_2;
      } else {
        tmp_10 = it_2;
      }
      var tmp$ret$12 = tmp_10;
      var tmp5_group = createDeferredAnimation(_this__u8e3s4, tmp_9, tmp$ret$12, $composer_0, 384 | 14 & $changed, 0);
      $composer_0.n30();
      tmp_8 = tmp5_group;
    } else {
      $composer_0.m30(-910935677);
      $composer_0.n30();
      tmp_8 = null;
    }
    var offsetAnimation = tmp_8;
    var tmp_11;
    var tmp_12;
    var tmp0_safe_receiver = activeEnter.zf3().uf3_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rf5_1) === false) {
      tmp_12 = true;
    } else {
      var tmp1_safe_receiver = activeExit.zf3().uf3_1;
      tmp_12 = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.rf5_1) === false;
    }
    if (tmp_12) {
      tmp_11 = true;
    } else {
      tmp_11 = !shouldAnimateSizeChange;
    }
    var disableClip = tmp_11;
    var tmp2_safe_receiver = activeEnter.zf3().wf3_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.sf5_1;
    var tmp_13;
    var tmp_14 = tmp3_safe_receiver;
    if ((tmp_14 == null ? null : new Color_0(tmp_14)) == null) {
      tmp_13 = null;
    } else {
      tmp_13 = _Color___get_colorSpace__impl__jqqozk(tmp3_safe_receiver);
    }
    var tmp4_elvis_lhs = tmp_13;
    var tmp_15;
    if (tmp4_elvis_lhs == null) {
      var tmp5_safe_receiver = activeEnter.zf3().wf3_1;
      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.tf5_1;
      var tmp_16;
      var tmp_17 = tmp6_safe_receiver;
      if ((tmp_17 == null ? null : new Color_0(tmp_17)) == null) {
        tmp_16 = null;
      } else {
        tmp_16 = _Color___get_colorSpace__impl__jqqozk(tmp6_safe_receiver);
      }
      tmp_15 = tmp_16;
    } else {
      tmp_15 = tmp4_elvis_lhs;
    }
    var tmp7_elvis_lhs = tmp_15;
    var tmp_18;
    if (tmp7_elvis_lhs == null) {
      var tmp8_safe_receiver = activeExit.zf3().wf3_1;
      var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.sf5_1;
      var tmp_19;
      var tmp_20 = tmp9_safe_receiver;
      if ((tmp_20 == null ? null : new Color_0(tmp_20)) == null) {
        tmp_19 = null;
      } else {
        tmp_19 = _Color___get_colorSpace__impl__jqqozk(tmp9_safe_receiver);
      }
      tmp_18 = tmp_19;
    } else {
      tmp_18 = tmp7_elvis_lhs;
    }
    var tmp10_elvis_lhs = tmp_18;
    var tmp_21;
    if (tmp10_elvis_lhs == null) {
      var tmp11_safe_receiver = activeExit.zf3().wf3_1;
      var tmp12_safe_receiver = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.tf5_1;
      var tmp_22;
      var tmp_23 = tmp12_safe_receiver;
      if ((tmp_23 == null ? null : new Color_0(tmp_23)) == null) {
        tmp_22 = null;
      } else {
        tmp_22 = _Color___get_colorSpace__impl__jqqozk(tmp12_safe_receiver);
      }
      tmp_21 = tmp_22;
    } else {
      tmp_21 = tmp10_elvis_lhs;
    }
    var tmp13_elvis_lhs = tmp_21;
    var colorSpace = tmp13_elvis_lhs == null ? ColorSpaces_getInstance().w6e_1 : tmp13_elvis_lhs;
    var tmp_24;
    if (shouldAnimateVeil) {
      $composer_0.m30(-910409203);
      var tmp_25 = get_VectorConverter_2(Companion_getInstance_4())(colorSpace);
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_3 = $composer_0.i31();
      var tmp_26;
      if (false || it_3 === Companion_getInstance().f30_1) {
        var value_3 = label + ' veil';
        $composer_0.j31(value_3);
        tmp_26 = value_3;
      } else {
        tmp_26 = it_3;
      }
      var tmp$ret$16 = tmp_26;
      var veilAnimation = createDeferredAnimation(_this__u8e3s4, tmp_25, tmp$ret$16, $composer_0, 384 | 14 & $changed, 0);
      var tmp6_group = new VeilModifierElement(_this__u8e3s4, veilAnimation, activeEnter, activeExit);
      $composer_0.n30();
      tmp_24 = tmp6_group;
    } else {
      $composer_0.m30(-910130296);
      $composer_0.n30();
      tmp_24 = Companion_instance;
    }
    var veilModifierElement = tmp_24;
    var tmp14_safe_receiver = activeEnter.zf3().wf3_1;
    var tmp15_elvis_lhs = tmp14_safe_receiver == null ? null : tmp14_safe_receiver.vf5_1;
    var tmp_27;
    if (tmp15_elvis_lhs == null) {
      var tmp16_safe_receiver = activeExit.zf3().wf3_1;
      tmp_27 = tmp16_safe_receiver == null ? null : tmp16_safe_receiver.vf5_1;
    } else {
      tmp_27 = tmp15_elvis_lhs;
    }
    var tmp17_elvis_lhs = tmp_27;
    var shouldVeilMatchParentSize = tmp17_elvis_lhs == null ? false : tmp17_elvis_lhs;
    var graphicsLayerBlock = createGraphicsLayerBlock(_this__u8e3s4, activeEnter, activeExit, label, $composer_0, 14 & $changed | 7168 & $changed >> 6);
    var tmp_28 = shouldVeilMatchParentSize ? veilModifierElement : Companion_instance;
    var tmp_29 = Companion_instance;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!($composer_0.l31(disableClip) | (($changed & 57344 ^ 24576) > 16384 && $composer_0.k31(isEnabled_0._v) || ($changed & 24576) === 16384));
    // Inline function 'kotlin.let' call
    var it_4 = $composer_0.i31();
    var tmp_30;
    if (invalid || it_4 === Companion_getInstance().f30_1) {
      var value_4 = createModifier$lambda_0(disableClip, isEnabled_0);
      $composer_0.j31(value_4);
      tmp_30 = value_4;
    } else {
      tmp_30 = it_4;
    }
    var tmp$ret$20 = tmp_30;
    return tmp_28.d8v(graphicsLayer(tmp_29, tmp$ret$20)).d8v(new EnterExitTransitionElement(_this__u8e3s4, sizeAnimation, offsetAnimation, slideAnimation, activeEnter, activeExit, isEnabled_0._v, graphicsLayerBlock)).d8v(!shouldVeilMatchParentSize ? veilModifierElement : Companion_instance);
  }
  function trackActiveEnter(_this__u8e3s4, enter, $composer, $changed) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(_this__u8e3s4) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = mutableStateOf(enter);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var activeEnter$delegate = tmp;
    if (_this__u8e3s4.v70().equals(_this__u8e3s4.o70()) && _this__u8e3s4.v70().equals(EnterExitState_Visible_getInstance())) {
      if (_this__u8e3s4.xep()) {
        trackActiveEnter$lambda_0(activeEnter$delegate, enter);
      } else {
        trackActiveEnter$lambda_0(activeEnter$delegate, Companion_getInstance_8().nf5_1);
      }
    } else if (_this__u8e3s4.o70().equals(EnterExitState_Visible_getInstance())) {
      trackActiveEnter$lambda_0(activeEnter$delegate, trackActiveEnter$lambda(activeEnter$delegate).rf3(enter));
    }
    return trackActiveEnter$lambda(activeEnter$delegate);
  }
  function trackActiveExit(_this__u8e3s4, exit, $composer, $changed) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(_this__u8e3s4) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = mutableStateOf(exit);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var activeExit$delegate = tmp;
    if (_this__u8e3s4.v70().equals(_this__u8e3s4.o70()) && _this__u8e3s4.v70().equals(EnterExitState_Visible_getInstance())) {
      if (_this__u8e3s4.xep()) {
        trackActiveExit$lambda_0(activeExit$delegate, exit);
      } else {
        trackActiveExit$lambda_0(activeExit$delegate, Companion_getInstance_9().ff4_1);
      }
    } else if (!_this__u8e3s4.o70().equals(EnterExitState_Visible_getInstance())) {
      trackActiveExit$lambda_0(activeExit$delegate, trackActiveExit$lambda(activeExit$delegate).jf4(exit));
    }
    return trackActiveExit$lambda(activeExit$delegate);
  }
  function TransitionData(fade, slide, changeSize, scale, veil, hold, effectsMap) {
    fade = fade === VOID ? null : fade;
    slide = slide === VOID ? null : slide;
    changeSize = changeSize === VOID ? null : changeSize;
    scale = scale === VOID ? null : scale;
    veil = veil === VOID ? null : veil;
    hold = hold === VOID ? false : hold;
    effectsMap = effectsMap === VOID ? emptyMap() : effectsMap;
    this.sf3_1 = fade;
    this.tf3_1 = slide;
    this.uf3_1 = changeSize;
    this.vf3_1 = scale;
    this.wf3_1 = veil;
    this.xf3_1 = hold;
    this.yf3_1 = effectsMap;
  }
  protoOf(TransitionData).toString = function () {
    return 'TransitionData(fade=' + toString(this.sf3_1) + ', slide=' + toString(this.tf3_1) + ', changeSize=' + toString(this.uf3_1) + ', scale=' + toString(this.vf3_1) + ', veil=' + toString(this.wf3_1) + ', hold=' + this.xf3_1 + ', effectsMap=' + toString_0(this.yf3_1) + ')';
  };
  protoOf(TransitionData).hashCode = function () {
    var result = this.sf3_1 == null ? 0 : this.sf3_1.hashCode();
    result = imul(result, 31) + (this.tf3_1 == null ? 0 : this.tf3_1.hashCode()) | 0;
    result = imul(result, 31) + (this.uf3_1 == null ? 0 : this.uf3_1.hashCode()) | 0;
    result = imul(result, 31) + (this.vf3_1 == null ? 0 : this.vf3_1.hashCode()) | 0;
    result = imul(result, 31) + (this.wf3_1 == null ? 0 : this.wf3_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.xf3_1) | 0;
    result = imul(result, 31) + hashCode(this.yf3_1) | 0;
    return result;
  };
  protoOf(TransitionData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TransitionData))
      return false;
    if (!equals(this.sf3_1, other.sf3_1))
      return false;
    if (!equals(this.tf3_1, other.tf3_1))
      return false;
    if (!equals(this.uf3_1, other.uf3_1))
      return false;
    if (!equals(this.vf3_1, other.vf3_1))
      return false;
    if (!equals(this.wf3_1, other.wf3_1))
      return false;
    if (!(this.xf3_1 === other.xf3_1))
      return false;
    if (!equals(this.yf3_1, other.yf3_1))
      return false;
    return true;
  };
  function EnterTransitionImpl(data) {
    EnterTransition.call(this);
    this.wf5_1 = data;
  }
  protoOf(EnterTransitionImpl).zf3 = function () {
    return this.wf5_1;
  };
  function Fade(alpha, animationSpec) {
    this.xf5_1 = alpha;
    this.yf5_1 = animationSpec;
  }
  protoOf(Fade).toString = function () {
    return 'Fade(alpha=' + this.xf5_1 + ', animationSpec=' + toString_0(this.yf5_1) + ')';
  };
  protoOf(Fade).hashCode = function () {
    var result = getNumberHashCode(this.xf5_1);
    result = imul(result, 31) + hashCode(this.yf5_1) | 0;
    return result;
  };
  protoOf(Fade).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Fade))
      return false;
    if (!equals(this.xf5_1, other.xf5_1))
      return false;
    if (!equals(this.yf5_1, other.yf5_1))
      return false;
    return true;
  };
  function Slide(slideOffset, animationSpec) {
    this.zf5_1 = slideOffset;
    this.af6_1 = animationSpec;
  }
  protoOf(Slide).toString = function () {
    return 'Slide(slideOffset=' + toString_0(this.zf5_1) + ', animationSpec=' + toString_0(this.af6_1) + ')';
  };
  protoOf(Slide).hashCode = function () {
    var result = hashCode(this.zf5_1);
    result = imul(result, 31) + hashCode(this.af6_1) | 0;
    return result;
  };
  protoOf(Slide).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Slide))
      return false;
    if (!equals(this.zf5_1, other.zf5_1))
      return false;
    if (!equals(this.af6_1, other.af6_1))
      return false;
    return true;
  };
  function ChangeSize$_init_$lambda_705jnq(it) {
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(0), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
    var tmp$ret$0 = _IntSize___init__impl__emcjft(tmp$ret$1);
    return new IntSize(tmp$ret$0);
  }
  function ChangeSize(alignment, size, animationSpec, clip) {
    var tmp;
    if (size === VOID) {
      tmp = ChangeSize$_init_$lambda_705jnq;
    } else {
      tmp = size;
    }
    size = tmp;
    clip = clip === VOID ? true : clip;
    this.of5_1 = alignment;
    this.pf5_1 = size;
    this.qf5_1 = animationSpec;
    this.rf5_1 = clip;
  }
  protoOf(ChangeSize).toString = function () {
    return 'ChangeSize(alignment=' + toString_0(this.of5_1) + ', size=' + toString_0(this.pf5_1) + ', animationSpec=' + toString_0(this.qf5_1) + ', clip=' + this.rf5_1 + ')';
  };
  protoOf(ChangeSize).hashCode = function () {
    var result = hashCode(this.of5_1);
    result = imul(result, 31) + hashCode(this.pf5_1) | 0;
    result = imul(result, 31) + hashCode(this.qf5_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.rf5_1) | 0;
    return result;
  };
  protoOf(ChangeSize).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ChangeSize))
      return false;
    if (!equals(this.of5_1, other.of5_1))
      return false;
    if (!equals(this.pf5_1, other.pf5_1))
      return false;
    if (!equals(this.qf5_1, other.qf5_1))
      return false;
    if (!(this.rf5_1 === other.rf5_1))
      return false;
    return true;
  };
  function Scale(scale, transformOrigin, animationSpec) {
    this.bf6_1 = scale;
    this.cf6_1 = transformOrigin;
    this.df6_1 = animationSpec;
  }
  protoOf(Scale).toString = function () {
    return 'Scale(scale=' + this.bf6_1 + ', transformOrigin=' + TransformOrigin__toString_impl_nn7ftd(this.cf6_1) + ', animationSpec=' + toString_0(this.df6_1) + ')';
  };
  protoOf(Scale).hashCode = function () {
    var result = getNumberHashCode(this.bf6_1);
    result = imul(result, 31) + TransformOrigin__hashCode_impl_pmqpcw(this.cf6_1) | 0;
    result = imul(result, 31) + hashCode(this.df6_1) | 0;
    return result;
  };
  protoOf(Scale).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Scale))
      return false;
    if (!equals(this.bf6_1, other.bf6_1))
      return false;
    if (!equals(this.cf6_1, other.cf6_1))
      return false;
    if (!equals(this.df6_1, other.df6_1))
      return false;
    return true;
  };
  function ExitTransitionImpl(data) {
    ExitTransition.call(this);
    this.ef6_1 = data;
  }
  protoOf(ExitTransitionImpl).zf3 = function () {
    return this.ef6_1;
  };
  function toAlignment(_this__u8e3s4) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return equals(_this__u8e3s4, Companion_getInstance_0().t8t_1) ? Companion_getInstance_0().l8t_1 : equals(_this__u8e3s4, Companion_getInstance_0().v8t_1) ? Companion_getInstance_0().r8t_1 : Companion_getInstance_0().o8t_1;
  }
  function VeilModifierElement(transition, veilAnimation, enter, exit) {
    ModifierNodeElement.call(this);
    this.gf6_1 = transition;
    this.hf6_1 = veilAnimation;
    this.if6_1 = enter;
    this.jf6_1 = exit;
  }
  protoOf(VeilModifierElement).r3d = function () {
    return new VeilModifierNode(this.gf6_1, this.hf6_1, this.if6_1, this.jf6_1);
  };
  protoOf(VeilModifierElement).kf6 = function (node) {
    node.zf6_1 = this.gf6_1;
    node.af7_1 = this.hf6_1;
    node.bf7_1 = this.if6_1;
    node.cf7_1 = this.jf6_1;
  };
  protoOf(VeilModifierElement).d8y = function (node) {
    return this.kf6(node instanceof VeilModifierNode ? node : THROW_CCE());
  };
  protoOf(VeilModifierElement).toString = function () {
    return 'VeilModifierElement(transition=' + this.gf6_1.toString() + ', veilAnimation=' + toString_0(this.hf6_1) + ', enter=' + this.if6_1.toString() + ', exit=' + this.jf6_1.toString() + ')';
  };
  protoOf(VeilModifierElement).hashCode = function () {
    var result = hashCode(this.gf6_1);
    result = imul(result, 31) + hashCode(this.hf6_1) | 0;
    result = imul(result, 31) + this.if6_1.hashCode() | 0;
    result = imul(result, 31) + this.jf6_1.hashCode() | 0;
    return result;
  };
  protoOf(VeilModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VeilModifierElement))
      return false;
    if (!equals(this.gf6_1, other.gf6_1))
      return false;
    if (!equals(this.hf6_1, other.hf6_1))
      return false;
    if (!this.if6_1.equals(other.if6_1))
      return false;
    if (!this.jf6_1.equals(other.jf6_1))
      return false;
    return true;
  };
  function GraphicsLayerBlockForEnterExit() {
  }
  function createGraphicsLayerBlock(_this__u8e3s4, enter, exit, label, $composer, $changed) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    var $composer_0 = $composer;
    var shouldAnimateAlpha = !(enter.zf3().sf3_1 == null) || !(exit.zf3().sf3_1 == null);
    var shouldAnimateScale = !(enter.zf3().vf3_1 == null) || !(exit.zf3().vf3_1 == null);
    var tmp;
    if (shouldAnimateAlpha) {
      $composer_0.m30(-703879421);
      var tmp_0 = get_VectorConverter_1(FloatCompanionObject_instance);
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var value = label + ' alpha';
        $composer_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp$ret$0 = tmp_1;
      var tmp1_group = createDeferredAnimation(_this__u8e3s4, tmp_0, tmp$ret$0, $composer_0, 384 | 14 & $changed, 0);
      $composer_0.n30();
      tmp = tmp1_group;
    } else {
      $composer_0.m30(-703709976);
      $composer_0.n30();
      tmp = null;
    }
    var alphaAnimation = tmp;
    var tmp_2;
    if (shouldAnimateScale) {
      $composer_0.m30(-703642333);
      var tmp_3 = get_VectorConverter_1(FloatCompanionObject_instance);
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_0 = $composer_0.i31();
      var tmp_4;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = label + ' scale';
        $composer_0.j31(value_0);
        tmp_4 = value_0;
      } else {
        tmp_4 = it_0;
      }
      var tmp$ret$4 = tmp_4;
      var tmp2_group = createDeferredAnimation(_this__u8e3s4, tmp_3, tmp$ret$4, $composer_0, 384 | 14 & $changed, 0);
      $composer_0.n30();
      tmp_2 = tmp2_group;
    } else {
      $composer_0.m30(-703472888);
      $composer_0.n30();
      tmp_2 = null;
    }
    var scaleAnimation = tmp_2;
    var tmp_5;
    if (shouldAnimateScale) {
      $composer_0.m30(-703395232);
      var tmp3_group = createDeferredAnimation(_this__u8e3s4, get_TransformOriginVectorConverter(), 'TransformOriginInterruptionHandling', $composer_0, 384 | 14 & $changed, 0);
      $composer_0.n30();
      tmp_5 = tmp3_group;
    } else {
      $composer_0.m30(-703222904);
      $composer_0.n30();
      tmp_5 = null;
    }
    var transformOriginAnimation = tmp_5;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!(!!(!!($composer_0.q31(alphaAnimation) | (($changed & 112 ^ 48) > 32 && $composer_0.k31(enter) || ($changed & 48) === 32)) | (($changed & 896 ^ 384) > 256 && $composer_0.k31(exit) || ($changed & 384) === 256)) | $composer_0.q31(scaleAnimation)) | (($changed & 14 ^ 6) > 4 && $composer_0.k31(_this__u8e3s4) || ($changed & 6) === 4)) | $composer_0.q31(transformOriginAnimation));
    // Inline function 'kotlin.let' call
    var it_1 = $composer_0.i31();
    var tmp_6;
    if (invalid || it_1 === Companion_getInstance().f30_1) {
      var tmp_7 = createGraphicsLayerBlock$lambda(alphaAnimation, scaleAnimation, _this__u8e3s4, enter, exit, transformOriginAnimation);
      var value_1 = new sam$androidx_compose_animation_GraphicsLayerBlockForEnterExit$0(tmp_7);
      $composer_0.j31(value_1);
      tmp_6 = value_1;
    } else {
      tmp_6 = it_1;
    }
    return tmp_6;
  }
  function EnterExitTransitionElement(transition, sizeAnimation, offsetAnimation, slideAnimation, enter, exit, isEnabled, graphicsLayerBlock) {
    ModifierNodeElement.call(this);
    this.ff7_1 = transition;
    this.gf7_1 = sizeAnimation;
    this.hf7_1 = offsetAnimation;
    this.if7_1 = slideAnimation;
    this.jf7_1 = enter;
    this.kf7_1 = exit;
    this.lf7_1 = isEnabled;
    this.mf7_1 = graphicsLayerBlock;
  }
  protoOf(EnterExitTransitionElement).r3d = function () {
    return new EnterExitTransitionModifierNode(this.ff7_1, this.gf7_1, this.hf7_1, this.if7_1, this.jf7_1, this.kf7_1, this.lf7_1, this.mf7_1);
  };
  protoOf(EnterExitTransitionElement).nf7 = function (node) {
    node.cf8_1 = this.ff7_1;
    node.df8_1 = this.gf7_1;
    node.ef8_1 = this.hf7_1;
    node.ff8_1 = this.if7_1;
    node.gf8_1 = this.jf7_1;
    node.hf8_1 = this.kf7_1;
    node.if8_1 = this.lf7_1;
    node.jf8_1 = this.mf7_1;
  };
  protoOf(EnterExitTransitionElement).d8y = function (node) {
    return this.nf7(node instanceof EnterExitTransitionModifierNode ? node : THROW_CCE());
  };
  protoOf(EnterExitTransitionElement).hashCode = function () {
    var tmp = imul(hashCode(this.ff7_1), 31);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.gf7_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp_0 = imul(tmp + tmp$ret$0 | 0, 31);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.hf7_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    var tmp$ret$1 = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
    var tmp_1 = imul(tmp_0 + tmp$ret$1 | 0, 31);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_1 = this.if7_1;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
    var tmp$ret$2 = tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1;
    return imul(imul(imul(imul(tmp_1 + tmp$ret$2 | 0, 31) + this.jf7_1.hashCode() | 0, 31) + this.kf7_1.hashCode() | 0, 31) + hashCode(this.lf7_1) | 0, 31) + hashCode(this.mf7_1) | 0;
  };
  protoOf(EnterExitTransitionElement).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    var tmp_6;
    if (other instanceof EnterExitTransitionElement) {
      tmp_6 = equals(other.ff7_1, this.ff7_1);
    } else {
      tmp_6 = false;
    }
    if (tmp_6) {
      tmp_5 = equals(other.gf7_1, this.gf7_1);
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = equals(other.hf7_1, this.hf7_1);
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = equals(other.if7_1, this.if7_1);
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = other.jf7_1.equals(this.jf7_1);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = other.kf7_1.equals(this.kf7_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = other.lf7_1 === this.lf7_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(other.mf7_1, this.mf7_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function VeilModifierNode$draw$lambda(this$0) {
    return function ($this$animate) {
      var tmp;
      if ($this$animate.teq(EnterExitState_PreEnter_getInstance(), EnterExitState_Visible_getInstance())) {
        var tmp0_safe_receiver = this$0.bf7_1.zf3().wf3_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.uf5_1;
        tmp = tmp1_elvis_lhs == null ? get_DefaultColorAnimationSpec() : tmp1_elvis_lhs;
      } else if ($this$animate.teq(EnterExitState_Visible_getInstance(), EnterExitState_PostExit_getInstance())) {
        var tmp2_safe_receiver = this$0.cf7_1.zf3().wf3_1;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.uf5_1;
        tmp = tmp3_elvis_lhs == null ? get_DefaultColorAnimationSpec() : tmp3_elvis_lhs;
      } else {
        tmp = get_DefaultColorAnimationSpec();
      }
      return tmp;
    };
  }
  function VeilModifierNode$draw$lambda_0(this$0) {
    return function (it) {
      var tmp;
      switch (it.a1_1) {
        case 1:
          var tmp1_safe_receiver = this$0.bf7_1.zf3().wf3_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.tf5_1;
          var tmp_0;
          var tmp_1 = tmp2_elvis_lhs;
          if ((tmp_1 == null ? null : new Color_0(tmp_1)) == null) {
            var tmp3_safe_receiver = this$0.cf7_1.zf3().wf3_1;
            tmp_0 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.sf5_1;
          } else {
            tmp_0 = tmp2_elvis_lhs;
          }

          var tmp4_elvis_lhs = tmp_0;
          var tmp_2;
          var tmp_3 = tmp4_elvis_lhs;
          if ((tmp_3 == null ? null : new Color_0(tmp_3)) == null) {
            tmp_2 = Companion_getInstance_4().t6b_1;
          } else {
            tmp_2 = tmp4_elvis_lhs;
          }

          tmp = tmp_2;
          break;
        case 0:
          var tmp5_safe_receiver = this$0.bf7_1.zf3().wf3_1;
          var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.sf5_1;
          var tmp_4;
          var tmp_5 = tmp6_elvis_lhs;
          if ((tmp_5 == null ? null : new Color_0(tmp_5)) == null) {
            tmp_4 = Companion_getInstance_4().t6b_1;
          } else {
            tmp_4 = tmp6_elvis_lhs;
          }

          tmp = tmp_4;
          break;
        case 2:
          var tmp7_safe_receiver = this$0.cf7_1.zf3().wf3_1;
          var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.tf5_1;
          var tmp_6;
          var tmp_7 = tmp8_elvis_lhs;
          if ((tmp_7 == null ? null : new Color_0(tmp_7)) == null) {
            tmp_6 = Companion_getInstance_4().t6b_1;
          } else {
            tmp_6 = tmp8_elvis_lhs;
          }

          tmp = tmp_6;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      return new Color_0(tmp);
    };
  }
  function VeilModifierNode(transition, veilAnimation, enter, exit) {
    Node.call(this);
    this.zf6_1 = transition;
    this.af7_1 = veilAnimation;
    this.bf7_1 = enter;
    this.cf7_1 = exit;
  }
  protoOf(VeilModifierNode).h92 = function (_this__u8e3s4) {
    _this__u8e3s4.z91();
    var tmp = this.af7_1;
    var tmp_0 = VeilModifierNode$draw$lambda(this);
    var veilColor = tmp.ueq(tmp_0, VeilModifierNode$draw$lambda_0(this));
    if (!(_Color___get_alpha__impl__wcfyv1(veilColor.u1().c6d_1) === 0.0)) {
      var tmp0_elvis_lhs = this.bf7_1.zf3().wf3_1;
      var veil = tmp0_elvis_lhs == null ? this.cf7_1.zf3().wf3_1 : tmp0_elvis_lhs;
      if ((veil == null ? null : veil.vf5_1) === true) {
        var layoutCoordinates = requireLayoutCoordinates(this);
        var tmp1_safe_receiver = layoutCoordinates.yah();
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.q95();
        var tmp_1;
        var tmp_2 = tmp2_safe_receiver;
        if ((tmp_2 == null ? null : new IntSize(tmp_2)) == null) {
          tmp_1 = null;
        } else {
          var tmp_3 = tmp2_safe_receiver;
          // Inline function 'kotlin.let' call
          var it = (tmp_3 == null ? null : new IntSize(tmp_3)).o5g_1;
          // Inline function 'androidx.compose.ui.unit.IntSize.width' call
          // Inline function 'androidx.compose.ui.util.unpackInt1' call
          var value = _IntSize___get_packedValue__impl__uho7jf(it);
          var tmp0 = convertToInt(shiftRight(value, 32));
          // Inline function 'androidx.compose.ui.unit.IntSize.height' call
          // Inline function 'androidx.compose.ui.util.unpackInt2' call
          var value_0 = _IntSize___get_packedValue__impl__uho7jf(it);
          // Inline function 'androidx.compose.ui.geometry.Size' call
          // Inline function 'androidx.compose.ui.util.packFloats' call
          var val2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
          var v1 = fromInt(toRawBits(tmp0));
          var v2 = fromInt(toRawBits(val2));
          var tmp$ret$7 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
          tmp_1 = _Size___init__impl__aywn0g(tmp$ret$7);
        }
        var tmp3_elvis_lhs = tmp_1;
        var tmp_4;
        var tmp_5 = tmp3_elvis_lhs;
        if ((tmp_5 == null ? null : new Size(tmp_5)) == null) {
          tmp_4 = Companion_getInstance_5().j5e_1;
        } else {
          tmp_4 = tmp3_elvis_lhs;
        }
        var parentSize = tmp_4;
        var offsetInParent = positionInParent(layoutCoordinates);
        var tmp4_color = veilColor.u1().c6d_1;
        // Inline function 'androidx.compose.ui.geometry.Offset.unaryMinus' call
        var tmp5_topLeft = _Offset___init__impl__c168vi(bitwiseXor(_Offset___get_packedValue__impl__xh2k8q(offsetInParent), new Long(-2147483648, -2147483648)));
        _this__u8e3s4.b6q(tmp4_color, tmp5_topLeft, parentSize);
      } else {
        _this__u8e3s4.b6q(veilColor.u1().c6d_1);
      }
    }
  };
  function _set_lookaheadConstraints__uusx37($this, value) {
    $this.kf8_1 = true;
    $this.mf8_1 = value;
  }
  function EnterExitTransitionModifierNode$sizeTransitionSpec$lambda(this$0) {
    return function (_this__u8e3s4) {
      var tmp;
      if (_this__u8e3s4.teq(EnterExitState_PreEnter_getInstance(), EnterExitState_Visible_getInstance())) {
        var tmp0_safe_receiver = this$0.gf8_1.zf3().uf3_1;
        tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qf5_1;
      } else if (_this__u8e3s4.teq(EnterExitState_Visible_getInstance(), EnterExitState_PostExit_getInstance())) {
        var tmp1_safe_receiver = this$0.hf8_1.zf3().uf3_1;
        tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.qf5_1;
      } else {
        tmp = get_DefaultSizeAnimationSpec();
      }
      var tmp2_elvis_lhs = tmp;
      return tmp2_elvis_lhs == null ? get_DefaultSizeAnimationSpec() : tmp2_elvis_lhs;
    };
  }
  function EnterExitTransitionModifierNode$measure$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.jal($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function EnterExitTransitionModifierNode$measure$lambda_0(this$0, $target) {
    return function (it) {
      return new IntSize(this$0.qf8(it, $target));
    };
  }
  function EnterExitTransitionModifierNode$measure$lambda_1($this$animate) {
    return get_DefaultOffsetAnimationSpec();
  }
  function EnterExitTransitionModifierNode$measure$lambda_2(this$0, $target) {
    return function (it) {
      return new IntOffset(this$0.rf8(it, $target));
    };
  }
  function EnterExitTransitionModifierNode$measure$lambda_3(this$0, $target) {
    return function (it) {
      return new IntOffset(this$0.sf8(it, $target));
    };
  }
  function EnterExitTransitionModifierNode$measure$lambda_4($placeable, $offset, $offsetDelta, $layerBlock) {
    return function ($this$layout) {
      $this$layout.sal($placeable, _IntOffset___get_x__impl__qiqr5o($offset) + _IntOffset___get_x__impl__qiqr5o($offsetDelta) | 0, _IntOffset___get_y__impl__2avpwj($offset) + _IntOffset___get_y__impl__2avpwj($offsetDelta) | 0, 0.0, $layerBlock);
      return Unit_instance;
    };
  }
  function EnterExitTransitionModifierNode$measure$lambda_5($$this$run) {
    return function ($this$layout) {
      $this$layout.jal($$this$run, 0, 0);
      return Unit_instance;
    };
  }
  function EnterExitTransitionModifierNode$slideSpec$lambda(this$0) {
    return function (_this__u8e3s4) {
      var tmp;
      if (_this__u8e3s4.teq(EnterExitState_PreEnter_getInstance(), EnterExitState_Visible_getInstance())) {
        var tmp0_safe_receiver = this$0.gf8_1.zf3().tf3_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.af6_1;
        tmp = tmp1_elvis_lhs == null ? get_DefaultOffsetAnimationSpec() : tmp1_elvis_lhs;
      } else if (_this__u8e3s4.teq(EnterExitState_Visible_getInstance(), EnterExitState_PostExit_getInstance())) {
        var tmp2_safe_receiver = this$0.hf8_1.zf3().tf3_1;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.af6_1;
        tmp = tmp3_elvis_lhs == null ? get_DefaultOffsetAnimationSpec() : tmp3_elvis_lhs;
      } else {
        tmp = get_DefaultOffsetAnimationSpec();
      }
      return tmp;
    };
  }
  function EnterExitTransitionModifierNode(transition, sizeAnimation, offsetAnimation, slideAnimation, enter, exit, isEnabled, graphicsLayerBlock) {
    LayoutModifierNodeWithPassThroughIntrinsics.call(this);
    this.cf8_1 = transition;
    this.df8_1 = sizeAnimation;
    this.ef8_1 = offsetAnimation;
    this.ff8_1 = slideAnimation;
    this.gf8_1 = enter;
    this.hf8_1 = exit;
    this.if8_1 = isEnabled;
    this.jf8_1 = graphicsLayerBlock;
    this.kf8_1 = false;
    this.lf8_1 = get_InvalidSize();
    this.mf8_1 = Constraints();
    this.nf8_1 = null;
    var tmp = this;
    tmp.of8_1 = EnterExitTransitionModifierNode$sizeTransitionSpec$lambda(this);
    var tmp_0 = this;
    tmp_0.pf8_1 = EnterExitTransitionModifierNode$slideSpec$lambda(this);
  }
  protoOf(EnterExitTransitionModifierNode).c63 = function () {
    // Inline function 'kotlin.with' call
    var tmp;
    if (this.cf8_1.yep().teq(EnterExitState_PreEnter_getInstance(), EnterExitState_Visible_getInstance())) {
      var tmp0_safe_receiver = this.gf8_1.zf3().uf3_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.of5_1;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp2_safe_receiver = this.hf8_1.zf3().uf3_1;
        tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.of5_1;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      var tmp3_safe_receiver = this.hf8_1.zf3().uf3_1;
      var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.of5_1;
      var tmp_1;
      if (tmp4_elvis_lhs == null) {
        var tmp5_safe_receiver = this.gf8_1.zf3().uf3_1;
        tmp_1 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.of5_1;
      } else {
        tmp_1 = tmp4_elvis_lhs;
      }
      tmp = tmp_1;
    }
    return tmp;
  };
  protoOf(EnterExitTransitionModifierNode).qf8 = function (targetState, fullSize) {
    var tmp;
    switch (targetState.a1_1) {
      case 1:
        tmp = fullSize;
        break;
      case 0:
        var tmp1_safe_receiver = this.gf8_1.zf3().uf3_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.pf5_1;
        var tmp_0;
        if (tmp2_safe_receiver == null) {
          tmp_0 = null;
        } else {
          var tmp_1 = tmp2_safe_receiver(new IntSize(fullSize));
          tmp_0 = tmp_1 == null ? null : tmp_1.o5g_1;
        }

        var tmp3_elvis_lhs = tmp_0;
        var tmp_2;
        var tmp_3 = tmp3_elvis_lhs;
        if ((tmp_3 == null ? null : new IntSize(tmp_3)) == null) {
          tmp_2 = fullSize;
        } else {
          tmp_2 = tmp3_elvis_lhs;
        }

        tmp = tmp_2;
        break;
      case 2:
        var tmp4_safe_receiver = this.hf8_1.zf3().uf3_1;
        var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.pf5_1;
        var tmp_4;
        if (tmp5_safe_receiver == null) {
          tmp_4 = null;
        } else {
          var tmp_5 = tmp5_safe_receiver(new IntSize(fullSize));
          tmp_4 = tmp_5 == null ? null : tmp_5.o5g_1;
        }

        var tmp6_elvis_lhs = tmp_4;
        var tmp_6;
        var tmp_7 = tmp6_elvis_lhs;
        if ((tmp_7 == null ? null : new IntSize(tmp_7)) == null) {
          tmp_6 = fullSize;
        } else {
          tmp_6 = tmp6_elvis_lhs;
        }

        tmp = tmp_6;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(EnterExitTransitionModifierNode).f8w = function () {
    protoOf(LayoutModifierNodeWithPassThroughIntrinsics).f8w.call(this);
    this.kf8_1 = false;
    this.lf8_1 = get_InvalidSize();
  };
  protoOf(EnterExitTransitionModifierNode).rf8 = function (targetState, fullSize) {
    var tmp;
    if (this.nf8_1 == null) {
      tmp = Companion_getInstance_3().c5g_1;
    } else if (this.c63() == null) {
      tmp = Companion_getInstance_3().c5g_1;
    } else if (equals(this.nf8_1, this.c63())) {
      tmp = Companion_getInstance_3().c5g_1;
    } else {
      var tmp_0;
      switch (targetState.a1_1) {
        case 1:
          tmp_0 = Companion_getInstance_3().c5g_1;
          break;
        case 0:
          tmp_0 = Companion_getInstance_3().c5g_1;
          break;
        case 2:
          var tmp1_safe_receiver = this.hf8_1.zf3().uf3_1;
          var tmp_1;
          if (tmp1_safe_receiver == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            var endSize = tmp1_safe_receiver.pf5_1(new IntSize(fullSize)).o5g_1;
            var targetOffset = ensureNotNull(this.c63()).f8u(fullSize, endSize, LayoutDirection_Ltr_getInstance());
            var currentOffset = ensureNotNull(this.nf8_1).f8u(fullSize, endSize, LayoutDirection_Ltr_getInstance());
            tmp_1 = IntOffset__minus_impl_4m69hb(targetOffset, currentOffset);
          }

          var tmp2_elvis_lhs = tmp_1;
          var tmp_2;
          var tmp_3 = tmp2_elvis_lhs;
          if ((tmp_3 == null ? null : new IntOffset(tmp_3)) == null) {
            tmp_2 = Companion_getInstance_3().c5g_1;
          } else {
            tmp_2 = tmp2_elvis_lhs;
          }

          tmp_0 = tmp_2;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(EnterExitTransitionModifierNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    if (this.cf8_1.v70().equals(this.cf8_1.o70())) {
      this.nf8_1 = null;
    } else if (this.nf8_1 == null) {
      var tmp = this;
      var tmp0_elvis_lhs = this.c63();
      tmp.nf8_1 = tmp0_elvis_lhs == null ? Companion_getInstance_0().k8t_1 : tmp0_elvis_lhs;
    }
    if (_this__u8e3s4.jag()) {
      var placeable = measurable.h8y(constraints);
      var tmp0 = placeable.i8y_1;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = placeable.j8y_1;
      var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var measuredSize = _IntSize___init__impl__emcjft(tmp$ret$1);
      this.lf8_1 = measuredSize;
      _set_lookaheadConstraints__uusx37(this, constraints);
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(measuredSize);
      var tmp_0 = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(measuredSize);
      var tmp_1 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      return _this__u8e3s4.n8y(tmp_0, tmp_1, VOID, EnterExitTransitionModifierNode$measure$lambda(placeable));
    } else if (this.if8_1()) {
      var layerBlock = this.jf8_1.df7();
      var placeable_0 = measurable.h8y(constraints);
      var tmp0_0 = placeable_0.i8y_1;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2_0 = placeable_0.j8y_1;
      var tmp$ret$7 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
      var measuredSize_0 = _IntSize___init__impl__emcjft(tmp$ret$7);
      var target = get_isValid(this.lf8_1) ? this.lf8_1 : measuredSize_0;
      var tmp1_safe_receiver = this.df8_1;
      var tmp_2;
      if (tmp1_safe_receiver == null) {
        tmp_2 = null;
      } else {
        tmp_2 = tmp1_safe_receiver.ueq(this.of8_1, EnterExitTransitionModifierNode$measure$lambda_0(this, target));
      }
      var animSize = tmp_2;
      var tmp_3;
      if (animSize == null) {
        tmp_3 = null;
      } else {
        var tmp_4 = animSize.u1();
        tmp_3 = tmp_4 == null ? null : tmp_4.o5g_1;
      }
      var tmp3_elvis_lhs = tmp_3;
      var tmp_5;
      var tmp_6 = tmp3_elvis_lhs;
      if ((tmp_6 == null ? null : new IntSize(tmp_6)) == null) {
        tmp_5 = measuredSize_0;
      } else {
        tmp_5 = tmp3_elvis_lhs;
      }
      var currentSize = constrain(constraints, tmp_5);
      var tmp4_safe_receiver = this.ef8_1;
      var tmp_7;
      if (tmp4_safe_receiver == null) {
        tmp_7 = null;
      } else {
        var tmp_8 = EnterExitTransitionModifierNode$measure$lambda_1;
        tmp_7 = tmp4_safe_receiver.ueq(tmp_8, EnterExitTransitionModifierNode$measure$lambda_2(this, target));
      }
      var tmp5_safe_receiver = tmp_7;
      var tmp_9;
      if (tmp5_safe_receiver == null) {
        tmp_9 = null;
      } else {
        var tmp_10 = tmp5_safe_receiver.u1();
        tmp_9 = tmp_10 == null ? null : tmp_10.a5g_1;
      }
      var tmp6_elvis_lhs = tmp_9;
      var tmp_11;
      var tmp_12 = tmp6_elvis_lhs;
      if ((tmp_12 == null ? null : new IntOffset(tmp_12)) == null) {
        tmp_11 = Companion_getInstance_3().c5g_1;
      } else {
        tmp_11 = tmp6_elvis_lhs;
      }
      var offsetDelta = tmp_11;
      var tmp7_safe_receiver = this.ff8_1;
      var tmp_13;
      if (tmp7_safe_receiver == null) {
        tmp_13 = null;
      } else {
        tmp_13 = tmp7_safe_receiver.ueq(this.pf8_1, EnterExitTransitionModifierNode$measure$lambda_3(this, target));
      }
      var tmp8_safe_receiver = tmp_13;
      var tmp_14;
      if (tmp8_safe_receiver == null) {
        tmp_14 = null;
      } else {
        var tmp_15 = tmp8_safe_receiver.u1();
        tmp_14 = tmp_15 == null ? null : tmp_15.a5g_1;
      }
      var tmp9_elvis_lhs = tmp_14;
      var tmp_16;
      var tmp_17 = tmp9_elvis_lhs;
      if ((tmp_17 == null ? null : new IntOffset(tmp_17)) == null) {
        tmp_16 = Companion_getInstance_3().c5g_1;
      } else {
        tmp_16 = tmp9_elvis_lhs;
      }
      var slideOffset = tmp_16;
      var tmp10_safe_receiver = this.nf8_1;
      var tmp11_elvis_lhs = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.f8u(target, currentSize, LayoutDirection_Ltr_getInstance());
      var tmp_18;
      var tmp_19 = tmp11_elvis_lhs;
      if ((tmp_19 == null ? null : new IntOffset(tmp_19)) == null) {
        tmp_18 = Companion_getInstance_3().c5g_1;
      } else {
        tmp_18 = tmp11_elvis_lhs;
      }
      var offset = IntOffset__plus_impl_nqoa9b(tmp_18, slideOffset);
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_1 = _IntSize___get_packedValue__impl__uho7jf(currentSize);
      var tmp_20 = convertToInt(shiftRight(value_1, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_2 = _IntSize___get_packedValue__impl__uho7jf(currentSize);
      var tmp_21 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      return _this__u8e3s4.n8y(tmp_20, tmp_21, VOID, EnterExitTransitionModifierNode$measure$lambda_4(placeable_0, offset, offsetDelta, layerBlock));
    } else {
      // Inline function 'kotlin.run' call
      var $this$run = measurable.h8y(constraints);
      var tmp_22 = $this$run.i8y_1;
      var tmp_23 = $this$run.j8y_1;
      return _this__u8e3s4.n8y(tmp_22, tmp_23, VOID, EnterExitTransitionModifierNode$measure$lambda_5($this$run));
    }
  };
  protoOf(EnterExitTransitionModifierNode).sf8 = function (targetState, fullSize) {
    var tmp0_safe_receiver = this.gf8_1.zf3().tf3_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zf5_1;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0 = tmp1_safe_receiver(new IntSize(fullSize));
      tmp = tmp_0 == null ? null : tmp_0.a5g_1;
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_1;
    var tmp_2 = tmp2_elvis_lhs;
    if ((tmp_2 == null ? null : new IntOffset(tmp_2)) == null) {
      tmp_1 = Companion_getInstance_3().c5g_1;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var preEnter = tmp_1;
    var tmp3_safe_receiver = this.hf8_1.zf3().tf3_1;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.zf5_1;
    var tmp_3;
    if (tmp4_safe_receiver == null) {
      tmp_3 = null;
    } else {
      var tmp_4 = tmp4_safe_receiver(new IntSize(fullSize));
      tmp_3 = tmp_4 == null ? null : tmp_4.a5g_1;
    }
    var tmp5_elvis_lhs = tmp_3;
    var tmp_5;
    var tmp_6 = tmp5_elvis_lhs;
    if ((tmp_6 == null ? null : new IntOffset(tmp_6)) == null) {
      tmp_5 = Companion_getInstance_3().c5g_1;
    } else {
      tmp_5 = tmp5_elvis_lhs;
    }
    var postExit = tmp_5;
    var tmp_7;
    switch (targetState.a1_1) {
      case 1:
        tmp_7 = Companion_getInstance_3().c5g_1;
        break;
      case 0:
        tmp_7 = preEnter;
        break;
      case 2:
        tmp_7 = postExit;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp_7;
  };
  function slideInHorizontally(animationSpec, initialOffsetX) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0, new IntOffset(get_VisibilityThreshold_0(Companion_getInstance_3()))) : animationSpec;
    var tmp;
    if (initialOffsetX === VOID) {
      tmp = slideInHorizontally$lambda;
    } else {
      tmp = initialOffsetX;
    }
    initialOffsetX = tmp;
    _init_properties_EnterExitTransition_kt__2obrqf();
    return slideIn(animationSpec, slideInHorizontally$lambda_0(initialOffsetX));
  }
  function slideOutHorizontally(animationSpec, targetOffsetX) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0, new IntOffset(get_VisibilityThreshold_0(Companion_getInstance_3()))) : animationSpec;
    var tmp;
    if (targetOffsetX === VOID) {
      tmp = slideOutHorizontally$lambda;
    } else {
      tmp = targetOffsetX;
    }
    targetOffsetX = tmp;
    _init_properties_EnterExitTransition_kt__2obrqf();
    return slideOut(animationSpec, slideOutHorizontally$lambda_0(targetOffsetX));
  }
  function slideInVertically(animationSpec, initialOffsetY) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0, new IntOffset(get_VisibilityThreshold_0(Companion_getInstance_3()))) : animationSpec;
    var tmp;
    if (initialOffsetY === VOID) {
      tmp = slideInVertically$lambda;
    } else {
      tmp = initialOffsetY;
    }
    initialOffsetY = tmp;
    _init_properties_EnterExitTransition_kt__2obrqf();
    return slideIn(animationSpec, slideInVertically$lambda_0(initialOffsetY));
  }
  function slideOutVertically(animationSpec, targetOffsetY) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0, new IntOffset(get_VisibilityThreshold_0(Companion_getInstance_3()))) : animationSpec;
    var tmp;
    if (targetOffsetY === VOID) {
      tmp = slideOutVertically$lambda;
    } else {
      tmp = targetOffsetY;
    }
    targetOffsetY = tmp;
    _init_properties_EnterExitTransition_kt__2obrqf();
    return slideOut(animationSpec, slideOutVertically$lambda_0(targetOffsetY));
  }
  function expandHorizontally(animationSpec, expandFrom, clip, initialWidth) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0, new IntSize(get_VisibilityThreshold(Companion_getInstance_2()))) : animationSpec;
    expandFrom = expandFrom === VOID ? Companion_getInstance_0().y8t_1 : expandFrom;
    clip = clip === VOID ? true : clip;
    var tmp;
    if (initialWidth === VOID) {
      tmp = expandHorizontally$lambda;
    } else {
      tmp = initialWidth;
    }
    initialWidth = tmp;
    _init_properties_EnterExitTransition_kt__2obrqf();
    var tmp_0 = toAlignment_0(expandFrom);
    return expandIn(animationSpec, tmp_0, clip, expandHorizontally$lambda_0(initialWidth));
  }
  function shrinkHorizontally(animationSpec, shrinkTowards, clip, targetWidth) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0, new IntSize(get_VisibilityThreshold(Companion_getInstance_2()))) : animationSpec;
    shrinkTowards = shrinkTowards === VOID ? Companion_getInstance_0().y8t_1 : shrinkTowards;
    clip = clip === VOID ? true : clip;
    var tmp;
    if (targetWidth === VOID) {
      tmp = shrinkHorizontally$lambda;
    } else {
      tmp = targetWidth;
    }
    targetWidth = tmp;
    _init_properties_EnterExitTransition_kt__2obrqf();
    var tmp_0 = toAlignment_0(shrinkTowards);
    return shrinkOut(animationSpec, tmp_0, clip, shrinkHorizontally$lambda_0(targetWidth));
  }
  function scaleIn(animationSpec, initialScale, transformOrigin) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0) : animationSpec;
    initialScale = initialScale === VOID ? 0.0 : initialScale;
    transformOrigin = transformOrigin === VOID ? Companion_getInstance_6().f9i_1 : transformOrigin;
    _init_properties_EnterExitTransition_kt__2obrqf();
    return new EnterTransitionImpl(new TransitionData(VOID, VOID, VOID, new Scale(initialScale, transformOrigin, animationSpec)));
  }
  function slideIn(animationSpec, initialOffset) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0, new IntOffset(get_VisibilityThreshold_0(Companion_getInstance_3()))) : animationSpec;
    _init_properties_EnterExitTransition_kt__2obrqf();
    return new EnterTransitionImpl(new TransitionData(VOID, new Slide(initialOffset, animationSpec)));
  }
  function slideOut(animationSpec, targetOffset) {
    animationSpec = animationSpec === VOID ? spring(VOID, 400.0, new IntOffset(get_VisibilityThreshold_0(Companion_getInstance_3()))) : animationSpec;
    _init_properties_EnterExitTransition_kt__2obrqf();
    return new ExitTransitionImpl(new TransitionData(VOID, new Slide(targetOffset, animationSpec)));
  }
  function toAlignment_0(_this__u8e3s4) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return equals(_this__u8e3s4, Companion_getInstance_0().w8t_1) ? Companion_getInstance_0().n8t_1 : equals(_this__u8e3s4, Companion_getInstance_0().y8t_1) ? Companion_getInstance_0().p8t_1 : Companion_getInstance_0().o8t_1;
  }
  function sam$androidx_compose_animation_GraphicsLayerBlockForEnterExit$0(function_0) {
    this.tf8_1 = function_0;
  }
  protoOf(sam$androidx_compose_animation_GraphicsLayerBlockForEnterExit$0).df7 = function () {
    return this.tf8_1();
  };
  protoOf(sam$androidx_compose_animation_GraphicsLayerBlockForEnterExit$0).q3 = function () {
    return this.tf8_1;
  };
  protoOf(sam$androidx_compose_animation_GraphicsLayerBlockForEnterExit$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, GraphicsLayerBlockForEnterExit) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_animation_GraphicsLayerBlockForEnterExit$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function TransformOriginVectorConverter$lambda(it) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return new AnimationVector2D(_TransformOrigin___get_pivotFractionX__impl__a9pmci(it.e9m_1), _TransformOrigin___get_pivotFractionY__impl__ijwupp(it.e9m_1));
  }
  function TransformOriginVectorConverter$lambda_0(it) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return new TransformOrigin_0(TransformOrigin(it.reg_1, it.seg_1));
  }
  function expandVertically$lambda(it) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return 0;
  }
  function expandVertically$lambda_0($initialHeight) {
    return function (it) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = it.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp0 = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_1 = it.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = $initialHeight(tmp$ret$2);
      var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$4 = _IntSize___init__impl__emcjft(tmp$ret$5);
      return new IntSize(tmp$ret$4);
    };
  }
  function shrinkVertically$lambda(it) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return 0;
  }
  function shrinkVertically$lambda_0($targetHeight) {
    return function (it) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = it.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp0 = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_1 = it.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = $targetHeight(tmp$ret$2);
      var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$4 = _IntSize___init__impl__emcjft(tmp$ret$5);
      return new IntSize(tmp$ret$4);
    };
  }
  function expandIn$lambda(it) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(0), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
    var tmp$ret$0 = _IntSize___init__impl__emcjft(tmp$ret$1);
    return new IntSize(tmp$ret$0);
  }
  function shrinkOut$lambda(it) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(0), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
    var tmp$ret$0 = _IntSize___init__impl__emcjft(tmp$ret$1);
    return new IntSize(tmp$ret$0);
  }
  function createModifier$lambda() {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return true;
  }
  function createModifier$lambda_0($disableClip, $isEnabled) {
    return function ($this$graphicsLayer) {
      $this$graphicsLayer.n67(!$disableClip && $isEnabled._v());
      return Unit_instance;
    };
  }
  function trackActiveEnter$lambda($activeEnter$delegate) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('activeEnter', KMutableProperty0, true);
    return $activeEnter$delegate.u1();
  }
  function trackActiveEnter$lambda_0($activeEnter$delegate, _set____db54di) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('activeEnter', KMutableProperty0, true);
    $activeEnter$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function trackActiveExit$lambda($activeExit$delegate) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('activeExit', KMutableProperty0, true);
    return $activeExit$delegate.u1();
  }
  function trackActiveExit$lambda_0($activeExit$delegate, _set____db54di) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('activeExit', KMutableProperty0, true);
    $activeExit$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function createGraphicsLayerBlock$lambda$lambda($enter, $exit) {
    return function ($this$animate) {
      var tmp;
      if ($this$animate.teq(EnterExitState_PreEnter_getInstance(), EnterExitState_Visible_getInstance())) {
        var tmp0_safe_receiver = $enter.zf3().sf3_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.yf5_1;
        tmp = tmp1_elvis_lhs == null ? get_DefaultAlphaAndScaleSpring() : tmp1_elvis_lhs;
      } else if ($this$animate.teq(EnterExitState_Visible_getInstance(), EnterExitState_PostExit_getInstance())) {
        var tmp2_safe_receiver = $exit.zf3().sf3_1;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.yf5_1;
        tmp = tmp3_elvis_lhs == null ? get_DefaultAlphaAndScaleSpring() : tmp3_elvis_lhs;
      } else {
        tmp = get_DefaultAlphaAndScaleSpring();
      }
      return tmp;
    };
  }
  function createGraphicsLayerBlock$lambda$lambda_0($enter, $exit) {
    return function (it) {
      var tmp;
      switch (it.a1_1) {
        case 1:
          tmp = 1.0;
          break;
        case 0:
          var tmp1_safe_receiver = $enter.zf3().sf3_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.xf5_1;
          tmp = tmp2_elvis_lhs == null ? 1.0 : tmp2_elvis_lhs;
          break;
        case 2:
          var tmp3_safe_receiver = $exit.zf3().sf3_1;
          var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.xf5_1;
          tmp = tmp4_elvis_lhs == null ? 1.0 : tmp4_elvis_lhs;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      return tmp;
    };
  }
  function createGraphicsLayerBlock$lambda$lambda_1($enter, $exit) {
    return function ($this$animate) {
      var tmp;
      if ($this$animate.teq(EnterExitState_PreEnter_getInstance(), EnterExitState_Visible_getInstance())) {
        var tmp0_safe_receiver = $enter.zf3().vf3_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.df6_1;
        tmp = tmp1_elvis_lhs == null ? get_DefaultAlphaAndScaleSpring() : tmp1_elvis_lhs;
      } else if ($this$animate.teq(EnterExitState_Visible_getInstance(), EnterExitState_PostExit_getInstance())) {
        var tmp2_safe_receiver = $exit.zf3().vf3_1;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.df6_1;
        tmp = tmp3_elvis_lhs == null ? get_DefaultAlphaAndScaleSpring() : tmp3_elvis_lhs;
      } else {
        tmp = get_DefaultAlphaAndScaleSpring();
      }
      return tmp;
    };
  }
  function createGraphicsLayerBlock$lambda$lambda_2($enter, $exit) {
    return function (it) {
      var tmp;
      switch (it.a1_1) {
        case 1:
          tmp = 1.0;
          break;
        case 0:
          var tmp1_safe_receiver = $enter.zf3().vf3_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.bf6_1;
          tmp = tmp2_elvis_lhs == null ? 1.0 : tmp2_elvis_lhs;
          break;
        case 2:
          var tmp3_safe_receiver = $exit.zf3().vf3_1;
          var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.bf6_1;
          tmp = tmp4_elvis_lhs == null ? 1.0 : tmp4_elvis_lhs;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      return tmp;
    };
  }
  function createGraphicsLayerBlock$lambda$lambda_3($this$animate) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return spring();
  }
  function createGraphicsLayerBlock$lambda$lambda_4($transformOriginWhenVisible, $enter, $exit) {
    return function (it) {
      var tmp;
      switch (it.a1_1) {
        case 1:
          tmp = $transformOriginWhenVisible;
          break;
        case 0:
          var tmp1_safe_receiver = $enter.zf3().vf3_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.cf6_1;
          var tmp_0;
          var tmp_1 = tmp2_elvis_lhs;
          if ((tmp_1 == null ? null : new TransformOrigin_0(tmp_1)) == null) {
            var tmp3_safe_receiver = $exit.zf3().vf3_1;
            tmp_0 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.cf6_1;
          } else {
            tmp_0 = tmp2_elvis_lhs;
          }

          tmp = tmp_0;
          break;
        case 2:
          var tmp4_safe_receiver = $exit.zf3().vf3_1;
          var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.cf6_1;
          var tmp_2;
          var tmp_3 = tmp5_elvis_lhs;
          if ((tmp_3 == null ? null : new TransformOrigin_0(tmp_3)) == null) {
            var tmp6_safe_receiver = $enter.zf3().vf3_1;
            tmp_2 = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.cf6_1;
          } else {
            tmp_2 = tmp5_elvis_lhs;
          }

          tmp = tmp_2;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var tmp7_elvis_lhs = tmp;
      var tmp_4;
      var tmp_5 = tmp7_elvis_lhs;
      if ((tmp_5 == null ? null : new TransformOrigin_0(tmp_5)) == null) {
        tmp_4 = Companion_getInstance_6().f9i_1;
      } else {
        tmp_4 = tmp7_elvis_lhs;
      }
      return new TransformOrigin_0(tmp_4);
    };
  }
  function createGraphicsLayerBlock$lambda$lambda_5($alpha, $scale, $transformOrigin) {
    return function (_this__u8e3s4) {
      var tmp0_safe_receiver = $alpha;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u1();
      _this__u8e3s4.v66(tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs);
      var tmp2_safe_receiver = $scale;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.u1();
      _this__u8e3s4.w66(tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs);
      var tmp4_safe_receiver = $scale;
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.u1();
      _this__u8e3s4.x66(tmp5_elvis_lhs == null ? 1.0 : tmp5_elvis_lhs);
      var tmp6_safe_receiver = $transformOrigin;
      var tmp;
      if (tmp6_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp_0 = tmp6_safe_receiver.u1();
        tmp = tmp_0 == null ? null : tmp_0.e9m_1;
      }
      var tmp7_elvis_lhs = tmp;
      var tmp_1;
      var tmp_2 = tmp7_elvis_lhs;
      if ((tmp_2 == null ? null : new TransformOrigin_0(tmp_2)) == null) {
        tmp_1 = Companion_getInstance_6().f9i_1;
      } else {
        tmp_1 = tmp7_elvis_lhs;
      }
      _this__u8e3s4.s9l(tmp_1);
      return Unit_instance;
    };
  }
  function createGraphicsLayerBlock$lambda($alphaAnimation, $scaleAnimation, $this_createGraphicsLayerBlock, $enter, $exit, $transformOriginAnimation) {
    return function () {
      var tmp0_safe_receiver = $alphaAnimation;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp_0 = createGraphicsLayerBlock$lambda$lambda($enter, $exit);
        tmp = tmp0_safe_receiver.ueq(tmp_0, createGraphicsLayerBlock$lambda$lambda_0($enter, $exit));
      }
      var alpha = tmp;
      var tmp1_safe_receiver = $scaleAnimation;
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        var tmp_2 = createGraphicsLayerBlock$lambda$lambda_1($enter, $exit);
        tmp_1 = tmp1_safe_receiver.ueq(tmp_2, createGraphicsLayerBlock$lambda$lambda_2($enter, $exit));
      }
      var scale = tmp_1;
      var tmp_3;
      if ($this_createGraphicsLayerBlock.v70().equals(EnterExitState_PreEnter_getInstance())) {
        var tmp2_safe_receiver = $enter.zf3().vf3_1;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.cf6_1;
        var tmp_4;
        var tmp_5 = tmp3_elvis_lhs;
        if ((tmp_5 == null ? null : new TransformOrigin_0(tmp_5)) == null) {
          var tmp4_safe_receiver = $exit.zf3().vf3_1;
          tmp_4 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.cf6_1;
        } else {
          tmp_4 = tmp3_elvis_lhs;
        }
        tmp_3 = tmp_4;
      } else {
        var tmp5_safe_receiver = $exit.zf3().vf3_1;
        var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.cf6_1;
        var tmp_6;
        var tmp_7 = tmp6_elvis_lhs;
        if ((tmp_7 == null ? null : new TransformOrigin_0(tmp_7)) == null) {
          var tmp7_safe_receiver = $enter.zf3().vf3_1;
          tmp_6 = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.cf6_1;
        } else {
          tmp_6 = tmp6_elvis_lhs;
        }
        tmp_3 = tmp_6;
      }
      var transformOriginWhenVisible = tmp_3;
      var tmp8_safe_receiver = $transformOriginAnimation;
      var tmp_8;
      if (tmp8_safe_receiver == null) {
        tmp_8 = null;
      } else {
        var tmp_9 = createGraphicsLayerBlock$lambda$lambda_3;
        tmp_8 = tmp8_safe_receiver.ueq(tmp_9, createGraphicsLayerBlock$lambda$lambda_4(transformOriginWhenVisible, $enter, $exit));
      }
      var transformOrigin = tmp_8;
      var block = createGraphicsLayerBlock$lambda$lambda_5(alpha, scale, transformOrigin);
      return block;
    };
  }
  function slideInHorizontally$lambda(it) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return (-it | 0) / 2 | 0;
  }
  function slideInHorizontally$lambda_0($initialOffsetX) {
    return function (it) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = it.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp$ret$0 = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val1 = $initialOffsetX(tmp$ret$0);
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(val1), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
      var tmp$ret$2 = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
      return new IntOffset(tmp$ret$2);
    };
  }
  function slideOutHorizontally$lambda(it) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return (-it | 0) / 2 | 0;
  }
  function slideOutHorizontally$lambda_0($targetOffsetX) {
    return function (it) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = it.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp$ret$0 = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val1 = $targetOffsetX(tmp$ret$0);
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(val1), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
      var tmp$ret$2 = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
      return new IntOffset(tmp$ret$2);
    };
  }
  function slideInVertically$lambda(it) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return (-it | 0) / 2 | 0;
  }
  function slideInVertically$lambda_0($initialOffsetY) {
    return function (it) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_0 = it.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp$ret$0 = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = $initialOffsetY(tmp$ret$0);
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$2 = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
      return new IntOffset(tmp$ret$2);
    };
  }
  function slideOutVertically$lambda(it) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return (-it | 0) / 2 | 0;
  }
  function slideOutVertically$lambda_0($targetOffsetY) {
    return function (it) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_0 = it.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp$ret$0 = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = $targetOffsetY(tmp$ret$0);
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$2 = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
      return new IntOffset(tmp$ret$2);
    };
  }
  function expandHorizontally$lambda(it) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return 0;
  }
  function expandHorizontally$lambda_0($initialWidth) {
    return function (it) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = it.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp$ret$0 = convertToInt(shiftRight(value, 32));
      var tmp0 = $initialWidth(tmp$ret$0);
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_1 = it.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$4 = _IntSize___init__impl__emcjft(tmp$ret$5);
      return new IntSize(tmp$ret$4);
    };
  }
  function shrinkHorizontally$lambda(it) {
    _init_properties_EnterExitTransition_kt__2obrqf();
    return 0;
  }
  function shrinkHorizontally$lambda_0($targetWidth) {
    return function (it) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = it.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp$ret$0 = convertToInt(shiftRight(value, 32));
      var tmp0 = $targetWidth(tmp$ret$0);
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_1 = it.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$4 = _IntSize___init__impl__emcjft(tmp$ret$5);
      return new IntSize(tmp$ret$4);
    };
  }
  var properties_initialized_EnterExitTransition_kt_te1nvp;
  function _init_properties_EnterExitTransition_kt__2obrqf() {
    if (!properties_initialized_EnterExitTransition_kt_te1nvp) {
      properties_initialized_EnterExitTransition_kt_te1nvp = true;
      var tmp = TransformOriginVectorConverter$lambda;
      TransformOriginVectorConverter = TwoWayConverter(tmp, TransformOriginVectorConverter$lambda_0);
      DefaultAlphaAndScaleSpring = spring(VOID, 400.0);
      DefaultColorAnimationSpec = spring(VOID, 400.0);
      DefaultOffsetAnimationSpec = spring(VOID, 400.0, new IntOffset(get_VisibilityThreshold_0(Companion_getInstance_3())));
      DefaultSizeAnimationSpec = spring(VOID, 400.0, new IntSize(get_VisibilityThreshold(Companion_getInstance_2())));
      androidx_compose_animation_EnterTransition$stable = 0;
      androidx_compose_animation_ExitTransition$stable = 0;
      androidx_compose_animation_TransitionEffect$stable = 0;
      androidx_compose_animation_ContentScaleTransitionEffect$stable = 0;
      androidx_compose_animation_Fade$stable = 0;
      androidx_compose_animation_Slide$stable = 0;
      androidx_compose_animation_ChangeSize$stable = 0;
      androidx_compose_animation_Scale$stable = 0;
      androidx_compose_animation_Veil$stable = 0;
      androidx_compose_animation_TransitionData$stable = 0;
    }
  }
  function get_DecelerationRate() {
    _init_properties_FlingCalculator_kt__ornu7o();
    return DecelerationRate;
  }
  var DecelerationRate;
  var androidx_compose_animation_FlingCalculator_FlingInfo$stable;
  var androidx_compose_animation_FlingCalculator$stable;
  function computeDeceleration($this, density) {
    return computeDeceleration_0(0.84, density.u5e());
  }
  function getSplineDeceleration($this, velocity) {
    return AndroidFlingSpline_getInstance().af9(velocity, $this.uf8_1 * $this.wf8_1);
  }
  function FlingInfo(initialVelocity, distance, duration) {
    this.bf9_1 = initialVelocity;
    this.cf9_1 = distance;
    this.df9_1 = duration;
  }
  protoOf(FlingInfo).ef9 = function (time) {
    var tmp;
    if (compare(this.df9_1, new Long(0, 0)) > 0) {
      // Inline function 'kotlin.Long.div' call
      var other = toNumber(this.df9_1);
      tmp = toNumber(time) / other;
    } else {
      tmp = 1.0;
    }
    var splinePos = tmp;
    // Inline function 'kotlin.math.sign' call
    var x = this.bf9_1;
    var tmp$ret$1 = sign(x);
    return this.cf9_1 * tmp$ret$1 * AndroidFlingSpline_getInstance().hf9(splinePos).ff9_1;
  };
  protoOf(FlingInfo).if9 = function (time) {
    var tmp;
    if (compare(this.df9_1, new Long(0, 0)) > 0) {
      // Inline function 'kotlin.Long.div' call
      var other = toNumber(this.df9_1);
      tmp = toNumber(time) / other;
    } else {
      tmp = 1.0;
    }
    var splinePos = tmp;
    var tmp_0 = AndroidFlingSpline_getInstance().hf9(splinePos).gf9_1;
    // Inline function 'kotlin.math.sign' call
    var x = this.bf9_1;
    return tmp_0 * sign(x) * this.cf9_1 / toNumber(this.df9_1) * 1000.0;
  };
  protoOf(FlingInfo).toString = function () {
    return 'FlingInfo(initialVelocity=' + this.bf9_1 + ', distance=' + this.cf9_1 + ', duration=' + this.df9_1.toString() + ')';
  };
  protoOf(FlingInfo).hashCode = function () {
    var result = getNumberHashCode(this.bf9_1);
    result = imul(result, 31) + getNumberHashCode(this.cf9_1) | 0;
    result = imul(result, 31) + this.df9_1.hashCode() | 0;
    return result;
  };
  protoOf(FlingInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FlingInfo))
      return false;
    if (!equals(this.bf9_1, other.bf9_1))
      return false;
    if (!equals(this.cf9_1, other.cf9_1))
      return false;
    if (!equalsLong(this.df9_1, other.df9_1))
      return false;
    return true;
  };
  function FlingCalculator(friction, density) {
    this.uf8_1 = friction;
    this.vf8_1 = density;
    this.wf8_1 = computeDeceleration(this, this.vf8_1);
  }
  protoOf(FlingCalculator).jf9 = function (velocity) {
    var l = getSplineDeceleration(this, velocity);
    var decelMinusOne = get_DecelerationRate() - 1.0;
    // Inline function 'kotlin.math.exp' call
    var x = l / decelMinusOne;
    var tmp$ret$0 = Math.exp(x);
    return numberToLong(1000.0 * tmp$ret$0);
  };
  protoOf(FlingCalculator).kf9 = function (velocity) {
    var l = getSplineDeceleration(this, velocity);
    var decelMinusOne = get_DecelerationRate() - 1.0;
    var tmp = this.uf8_1 * this.wf8_1;
    // Inline function 'kotlin.math.exp' call
    var x = get_DecelerationRate() / decelMinusOne * l;
    return tmp * Math.exp(x);
  };
  protoOf(FlingCalculator).lf9 = function (velocity) {
    var l = getSplineDeceleration(this, velocity);
    var decelMinusOne = get_DecelerationRate() - 1.0;
    var tmp = this.uf8_1 * this.wf8_1;
    // Inline function 'kotlin.math.exp' call
    var x = get_DecelerationRate() / decelMinusOne * l;
    var tmp_0 = tmp * Math.exp(x);
    // Inline function 'kotlin.math.exp' call
    var x_0 = l / decelMinusOne;
    var tmp$ret$1 = Math.exp(x_0);
    return new FlingInfo(velocity, tmp_0, numberToLong(1000.0 * tmp$ret$1));
  };
  function computeDeceleration_0(friction, density) {
    _init_properties_FlingCalculator_kt__ornu7o();
    return 9.80665 * 39.37 * density * 160.0 * friction;
  }
  var properties_initialized_FlingCalculator_kt_aw7aky;
  function _init_properties_FlingCalculator_kt__ornu7o() {
    if (!properties_initialized_FlingCalculator_kt_aw7aky) {
      properties_initialized_FlingCalculator_kt_aw7aky = true;
      // Inline function 'kotlin.math.ln' call
      var tmp = Math.log(0.78);
      // Inline function 'kotlin.math.ln' call
      DecelerationRate = tmp / Math.log(0.9);
      androidx_compose_animation_FlingCalculator_FlingInfo$stable = 0;
      androidx_compose_animation_FlingCalculator$stable = 0;
    }
  }
  var isLookaheadAnimationVisualDebuggingEnabled;
  var androidx_compose_animation_LookaheadAnimationVisualDebugConfig$stable;
  var androidx_compose_animation_RenderInTransitionOverlayNodeElement$stable;
  var androidx_compose_animation_RenderInTransitionOverlayNode$stable;
  var androidx_compose_animation_SharedElementEntry$stable;
  function get_DefaultSpring() {
    _init_properties_SharedTransitionScope_kt__irnofc();
    return DefaultSpring;
  }
  var DefaultSpring;
  function get_ParentClip() {
    _init_properties_SharedTransitionScope_kt__irnofc();
    return ParentClip;
  }
  var ParentClip;
  var cachedScaleToBoundsImplMap;
  var androidx_compose_animation_SharedTransitionScope_SharedContentState$stable;
  var androidx_compose_animation_SharedTransitionScopeImpl$stable;
  var androidx_compose_animation_ScaleToBoundsImpl$stable;
  var androidx_compose_animation_SharedTransitionDefaults_SharedContentConfig$stable;
  var androidx_compose_animation_SharedTransitionDefaults$stable;
  function BoundsTransform() {
  }
  function sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0(function_0) {
    this.mf9_1 = function_0;
  }
  protoOf(sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0).q3 = function () {
    return this.mf9_1;
  };
  protoOf(sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PlaceholderSize) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0_0(function_0) {
    this.nf9_1 = function_0;
  }
  protoOf(sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0_0).q3 = function () {
    return this.nf9_1;
  };
  protoOf(sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PlaceholderSize) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function SharedTransitionScope$PlaceholderSize$Companion$AnimatedSize$lambda(_unused_var__etf5q3, animatedSize) {
    return animatedSize;
  }
  function SharedTransitionScope$PlaceholderSize$Companion$ContentSize$lambda(contentSize, _unused_var__etf5q3) {
    return contentSize;
  }
  function Companion_1() {
    Companion_instance_2 = this;
    var tmp = this;
    var tmp_0 = SharedTransitionScope$PlaceholderSize$Companion$AnimatedSize$lambda;
    tmp.of9_1 = new sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0(tmp_0);
    var tmp_1 = this;
    var tmp_2 = SharedTransitionScope$PlaceholderSize$Companion$ContentSize$lambda;
    tmp_1.pf9_1 = new sam$androidx_compose_animation_SharedTransitionScope_PlaceholderSize$0_0(tmp_2);
  }
  var Companion_instance_2;
  function Companion_getInstance_10() {
    if (Companion_instance_2 == null)
      new Companion_1();
    return Companion_instance_2;
  }
  function SharedTransitionScope$SharedContentState$_get_config_$ref_65x4et() {
    return constructCallableReference(function (p0) {
      return p0.tf9();
    }, 1, 0, 236);
  }
  function SharedTransitionScope$SharedContentState$_set_config_$ref_l85pk1() {
    return constructCallableReference(function (p0, p1) {
      p0.uf9(p1);
      return Unit_instance;
    }, 2, 0, 237);
  }
  function PlaceholderSize() {
  }
  function SharedContentState(key, config) {
    config = config === VOID ? SharedContentConfig_instance : config;
    this.qf9_1 = key;
    this.rf9_1 = mutableStateOf(config);
    this.sf9_1 = mutableStateOf(null);
  }
  protoOf(SharedContentState).uf9 = function (_set____db54di) {
    var tmp0 = this.rf9_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SharedTransitionScope$SharedContentState$_get_config_$ref_65x4et();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('config', 1, tmp, tmp_0, SharedTransitionScope$SharedContentState$_set_config_$ref_l85pk1());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(SharedContentState).tf9 = function () {
    var tmp0 = this.rf9_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SharedTransitionScope$SharedContentState$_get_config_$ref_65x4et();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('config', 1, tmp, tmp_0, SharedTransitionScope$SharedContentState$_set_config_$ref_l85pk1());
    return tmp0.u1();
  };
  function SharedTransitionScope() {
  }
  function SharedContentConfig() {
  }
  var SharedContentConfig_instance;
  function SharedContentConfig_getInstance() {
    return SharedContentConfig_instance;
  }
  function sam$androidx_compose_animation_BoundsTransform$0(function_0) {
    this.afa_1 = function_0;
  }
  protoOf(sam$androidx_compose_animation_BoundsTransform$0).q3 = function () {
    return this.afa_1;
  };
  protoOf(sam$androidx_compose_animation_BoundsTransform$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, BoundsTransform) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_animation_BoundsTransform$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function SharedTransitionDefaults$BoundsTransform$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
    return get_DefaultSpring();
  }
  function SharedTransitionDefaults() {
    SharedTransitionDefaults_instance = this;
    var tmp = this;
    var tmp_0 = SharedTransitionDefaults$BoundsTransform$lambda;
    tmp.xf9_1 = new sam$androidx_compose_animation_BoundsTransform$0(tmp_0);
  }
  var SharedTransitionDefaults_instance;
  function SharedTransitionDefaults_getInstance() {
    if (SharedTransitionDefaults_instance == null)
      new SharedTransitionDefaults();
    return SharedTransitionDefaults_instance;
  }
  function ParentClip$1() {
  }
  var properties_initialized_SharedTransitionScope_kt_rkj5u2;
  function _init_properties_SharedTransitionScope_kt__irnofc() {
    if (!properties_initialized_SharedTransitionScope_kt_rkj5u2) {
      properties_initialized_SharedTransitionScope_kt_rkj5u2 = true;
      DefaultSpring = spring(VOID, 400.0, get_VisibilityThreshold_1(Companion_getInstance_7()));
      ParentClip = new ParentClip$1();
      cachedScaleToBoundsImplMap = new MutableScatterMap();
      androidx_compose_animation_SharedTransitionScope_SharedContentState$stable = 8;
      androidx_compose_animation_SharedTransitionScopeImpl$stable = 0;
      androidx_compose_animation_ScaleToBoundsImpl$stable = 0;
      androidx_compose_animation_SharedTransitionDefaults_SharedContentConfig$stable = 0;
      androidx_compose_animation_SharedTransitionDefaults$stable = 8;
    }
  }
  var androidx_compose_animation_SharedTransitionStateMachine_State$stable;
  var androidx_compose_animation_SharedTransitionStateMachine$stable;
  var androidx_compose_animation_NoMatchFound$stable;
  var androidx_compose_animation_ActiveMatchFoundConfigPending$stable;
  var androidx_compose_animation_MatchIsOrHasBeenConfigured$stable;
  var androidx_compose_animation_ActiveMatchConfigured$stable;
  var androidx_compose_animation_ActiveMatchRemovedDuringTransition$stable;
  var androidx_compose_animation_TargetData$stable;
  function get_colorDefaultSpring() {
    _init_properties_SingleValueAnimation_kt__hxy1sr();
    return colorDefaultSpring;
  }
  var colorDefaultSpring;
  function animateColorAsState(targetValue, animationSpec, label, finishedListener, $composer, $changed, $default) {
    _init_properties_SingleValueAnimation_kt__hxy1sr();
    var animationSpec_0 = animationSpec;
    var label_0 = label;
    var finishedListener_0 = finishedListener;
    var $composer_0 = $composer;
    if (!(($default & 2) === 0))
      animationSpec_0 = get_colorDefaultSpring();
    if (!(($default & 4) === 0))
      label_0 = 'ColorAnimation';
    if (!(($default & 8) === 0))
      finishedListener_0 = null;
    var tmp1_remember$arg$0 = _Color___get_colorSpace__impl__jqqozk(targetValue);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.k31(tmp1_remember$arg$0);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = get_VectorConverter_2(Companion_getInstance_4())(_Color___get_colorSpace__impl__jqqozk(targetValue));
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var converter = tmp;
    var tmp_0 = animationSpec_0;
    return animateValueAsState(new Color_0(targetValue), converter, tmp_0, null, label_0, finishedListener_0, $composer_0, 14 & $changed | 896 & $changed << 3 | 57344 & $changed << 6 | 458752 & $changed << 6, 8);
  }
  var properties_initialized_SingleValueAnimation_kt_kqgwkj;
  function _init_properties_SingleValueAnimation_kt__hxy1sr() {
    if (!properties_initialized_SingleValueAnimation_kt_kqgwkj) {
      properties_initialized_SingleValueAnimation_kt_kqgwkj = true;
      colorDefaultSpring = spring();
    }
  }
  var androidx_compose_animation_AndroidFlingSpline_FlingResult$stable;
  var androidx_compose_animation_AndroidFlingSpline$stable;
  function FlingResult(distanceCoefficient, velocityCoefficient) {
    this.ff9_1 = distanceCoefficient;
    this.gf9_1 = velocityCoefficient;
  }
  protoOf(FlingResult).toString = function () {
    return 'FlingResult(distanceCoefficient=' + this.ff9_1 + ', velocityCoefficient=' + this.gf9_1 + ')';
  };
  protoOf(FlingResult).hashCode = function () {
    var result = getNumberHashCode(this.ff9_1);
    result = imul(result, 31) + getNumberHashCode(this.gf9_1) | 0;
    return result;
  };
  protoOf(FlingResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FlingResult))
      return false;
    if (!equals(this.ff9_1, other.ff9_1))
      return false;
    if (!equals(this.gf9_1, other.gf9_1))
      return false;
    return true;
  };
  function AndroidFlingSpline() {
    AndroidFlingSpline_instance = this;
    this.xf8_1 = 100;
    this.yf8_1 = new Float32Array(101);
    this.zf8_1 = new Float32Array(101);
    computeSplineInfo(this.yf8_1, this.zf8_1, 100);
  }
  protoOf(AndroidFlingSpline).hf9 = function (time) {
    var clampedTime = coerceIn(time, 0.0, 1.0);
    var index = numberToInt(100 * clampedTime);
    var distanceCoef = 1.0;
    var velocityCoef = 0.0;
    if (index < 100) {
      var tInf = index / 100;
      var tSup = (index + 1 | 0) / 100;
      var dInf = this.yf8_1[index];
      var dSup = this.yf8_1[index + 1 | 0];
      velocityCoef = (dSup - dInf) / (tSup - tInf);
      distanceCoef = dInf + (clampedTime - tInf) * velocityCoef;
    }
    return new FlingResult(distanceCoef, velocityCoef);
  };
  protoOf(AndroidFlingSpline).af9 = function (velocity, friction) {
    // Inline function 'kotlin.math.abs' call
    // Inline function 'kotlin.math.ln' call
    var x = 0.35 * Math.abs(velocity) / friction;
    return Math.log(x);
  };
  var AndroidFlingSpline_instance;
  function AndroidFlingSpline_getInstance() {
    if (AndroidFlingSpline_instance == null)
      new AndroidFlingSpline();
    return AndroidFlingSpline_instance;
  }
  function computeSplineInfo(splinePositions, splineTimes, nbSamples) {
    var xMin = 0.0;
    var yMin = 0.0;
    var inductionVariable = 0;
    if (inductionVariable < nbSamples)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var alpha = i / nbSamples;
        var xMax = 1.0;
        var x;
        var tx;
        var coef;
        $l$loop: while (true) {
          x = xMin + (xMax - xMin) / 2.0;
          coef = 3.0 * x * (1.0 - x);
          tx = coef * ((1.0 - x) * 0.175 + x * 0.35000002) + x * x * x;
          // Inline function 'kotlin.math.abs' call
          var x_0 = tx - alpha;
          if (Math.abs(x_0) < 1.0E-5)
            break $l$loop;
          if (tx > alpha)
            xMax = x;
          else
            xMin = x;
        }
        splinePositions[i] = coef * ((1.0 - x) * 0.5 + x) + x * x * x;
        var yMax = 1.0;
        var y;
        var dy;
        $l$loop_0: while (true) {
          y = yMin + (yMax - yMin) / 2.0;
          coef = 3.0 * y * (1.0 - y);
          dy = coef * ((1.0 - y) * 0.5 + y) + y * y * y;
          // Inline function 'kotlin.math.abs' call
          var x_1 = dy - alpha;
          if (Math.abs(x_1) < 1.0E-5)
            break $l$loop_0;
          if (dy > alpha)
            yMax = y;
          else
            yMin = y;
        }
        splineTimes[i] = coef * ((1.0 - y) * 0.175 + y * 0.35000002) + y * y * y;
      }
       while (inductionVariable < nbSamples);
    splineTimes[nbSamples] = 1.0;
    splinePositions[nbSamples] = splineTimes[nbSamples];
  }
  function splineBasedDecay(density) {
    return generateDecayAnimationSpec(new SplineBasedFloatDecayAnimationSpec(density));
  }
  var androidx_compose_animation_SplineBasedFloatDecayAnimationSpec$stable;
  function flingDistance($this, startVelocity) {
    var tmp = $this.bfa_1.kf9(startVelocity);
    // Inline function 'kotlin.math.sign' call
    return tmp * sign(startVelocity);
  }
  function SplineBasedFloatDecayAnimationSpec(density) {
    this.bfa_1 = new FlingCalculator(get_platformFlingScrollFriction(), density);
  }
  protoOf(SplineBasedFloatDecayAnimationSpec).zee = function () {
    return 0.0;
  };
  protoOf(SplineBasedFloatDecayAnimationSpec).jei = function (initialValue, initialVelocity) {
    return initialValue + flingDistance(this, initialVelocity);
  };
  protoOf(SplineBasedFloatDecayAnimationSpec).gei = function (playTimeNanos, initialValue, initialVelocity) {
    var playTimeMillis = divide(playTimeNanos, new Long(1000000, 0));
    return initialValue + this.bfa_1.lf9(initialVelocity).ef9(playTimeMillis);
  };
  protoOf(SplineBasedFloatDecayAnimationSpec).hei = function (initialValue, initialVelocity) {
    return multiply(this.bfa_1.jf9(initialVelocity), new Long(1000000, 0));
  };
  protoOf(SplineBasedFloatDecayAnimationSpec).iei = function (playTimeNanos, initialValue, initialVelocity) {
    var playTimeMillis = divide(playTimeNanos, new Long(1000000, 0));
    return this.bfa_1.lf9(initialVelocity).if9(playTimeMillis);
  };
  function get_platformFlingScrollFriction() {
    return platformFlingScrollFriction;
  }
  var platformFlingScrollFriction;
  function rememberSplineBasedDecay($composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalDensity();
    var $composer_1 = $composer_0;
    var density = $composer_1.u31(this_0);
    var tmp1_remember$arg$0 = density.u5e();
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.n31(tmp1_remember$arg$0);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = generateDecayAnimationSpec(new SplineBasedFloatDecayAnimationSpec(density));
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  //region block: post-declaration
  protoOf(ChildData).h8v = foldIn;
  protoOf(ChildData).i8v = all;
  protoOf(ChildData).d8v = then;
  protoOf(AnimatedContentTransitionScopeImpl).teq = isTransitioningTo;
  protoOf(VeilModifierNode).v95 = onMeasureResultChanged;
  //endregion
  //region block: init
  androidx_compose_animation_AnimatedVisibilityScopeImpl$stable = 8;
  isLookaheadAnimationVisualDebuggingEnabled = true;
  androidx_compose_animation_LookaheadAnimationVisualDebugConfig$stable = 0;
  androidx_compose_animation_RenderInTransitionOverlayNodeElement$stable = 0;
  androidx_compose_animation_RenderInTransitionOverlayNode$stable = 8;
  androidx_compose_animation_SharedElementEntry$stable = 8;
  SharedContentConfig_instance = new SharedContentConfig();
  androidx_compose_animation_SharedTransitionStateMachine_State$stable = 0;
  androidx_compose_animation_SharedTransitionStateMachine$stable = 8;
  androidx_compose_animation_NoMatchFound$stable = 0;
  androidx_compose_animation_ActiveMatchFoundConfigPending$stable = 8;
  androidx_compose_animation_MatchIsOrHasBeenConfigured$stable = 0;
  androidx_compose_animation_ActiveMatchConfigured$stable = 0;
  androidx_compose_animation_ActiveMatchRemovedDuringTransition$stable = 8;
  androidx_compose_animation_TargetData$stable = 0;
  androidx_compose_animation_AndroidFlingSpline_FlingResult$stable = 0;
  androidx_compose_animation_AndroidFlingSpline$stable = 8;
  androidx_compose_animation_SplineBasedFloatDecayAnimationSpec$stable = 0;
  platformFlingScrollFriction = 0.015;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = AnimatedContent_0;
  _.$_$.b = AnimatedContent;
  _.$_$.c = AnimatedVisibility;
  _.$_$.d = ContentTransform;
  _.$_$.e = SizeTransform;
  _.$_$.f = SplineBasedFloatDecayAnimationSpec;
  _.$_$.g = get_VectorConverter_2;
  _.$_$.h = animateColorAsState;
  _.$_$.i = expandHorizontally;
  _.$_$.j = expandVertically;
  _.$_$.k = fadeIn;
  _.$_$.l = fadeOut;
  _.$_$.m = rememberSplineBasedDecay;
  _.$_$.n = shrinkHorizontally;
  _.$_$.o = shrinkVertically;
  _.$_$.p = slideInHorizontally;
  _.$_$.q = slideInVertically;
  _.$_$.r = slideOutHorizontally;
  _.$_$.s = slideOutVertically;
  _.$_$.t = splineBasedDecay;
  _.$_$.u = togetherWith;
  _.$_$.v = Companion_getInstance_8;
  _.$_$.w = Companion_getInstance_9;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-animation-animation.js.map
